{
  "common": {
    "no_access": "Du har inte åtkomst till den här modulen"
  },
  "settings": {
    "calendar": {
      "calendar_settings": "Kalenderinställningar",
      "settings": "Inställningar",
      "select_calendar_type": "Välj kalendertyp",
      "add_new_calendar_group": "Lägg till ny kalendergrupp",
      "add_new_equipment": "Lägg till ny utrustning",
      "new_calendar": "Ny kalender",
      "calendar_group_description": "Använd kalendergrupper för att effektivt organisera och gruppera flera kalendrar tillsammans.",
      "group": "Grupp",
      "manage_your_calendars_and_groups": "Hantera dina kalendrar och grupper",
      "groups": "Grupper",
      "create_group": "Skapa grupp",
      "create_calendar": "Skapa kalender",
      "calendar_name": "Kalenderns namn",
      "group_duration": "Gruppens varaktighet",
      "calendar_type": "Typ",
      "action": "Åtgärd",
      "round_robin": "Round robin",
      "event": "Händelse",
      "group_name": "Gruppnamn",
      "room_name": "Rumsnamn",
      "group_description": "Gruppbeskrivning",
      "calendar_url": "Kalenderns URL",
      "calendars": "Kalendrar",
      "date_updated": "Uppdaterad den",
      "status": "Status",
      "action_dropdown": "Rullgardinsmeny för åtgärder",
      "calendar_list": "Tjänster kopplade till",
      "edit": "Redigera",
      "duplicate": "Duplicera",
      "copy_embed_code": "Kopiera inbäddningskod",
      "copy_permanent_link": "Kopiera permanent länk",
      "copy_new_slug_link": "Kopiera schemaläggningslänk",
      "copy_scheduling_link": "Kopiera schemaläggningslänk (föråldrad version)",
      "deactivate_calendar": "Inaktivera kalender",
      "move_to_group": "Flytta till grupp",
      "delete_calendar": "Ta bort kalender",
      "delete_group": "Radera",
      "delete_this_group": "Ta bort gruppen",
      "activate_calendar": "Aktivera kalender",
      "duration": "Varaktighet",
      "all": "Alla",
      "draft": "Utkast",
      "inactive": "Inaktiv",
      "active": "Aktiv",
      "actions": "aktiviteter",
      "rearrange_calendars": "Omorganisera kalendrar",
      "deactivate_all_calendars_in_group": "Inaktivera alla kalendrar i gruppen",
      "activate_all_calendars_in_group": "Aktivera alla kalendrar i gruppen",
      "no_groups_found": "Din sökning matchade inte några kalendergrupper.",
      "no_groups_in_location": "Grupp Sortera dina kalendrar Gilla Mapp. Lägg till kalendrar i en Grupp och Dela a Individ Schemaläggningslänk, uthyrning Bokare Välj Från flera kalendrar.",
      "no_calendars_found": "Kom igång med kalendern genom att skapa en ny kalender.",
      "no_calendars_found_search": "Din sökning matchade inte några kalendrar.",
      "delete_calendar_message": "Du är på väg att ta bort en kalender. När du trycker på radera kommer det också att radera alla dess möten.",
      "delete_calendar_message_title": "Vill du ta bort den här kalendern?",
      "duplicate_calendar_message": "Du är på väg att duplicera en kalender. Detta skapar en ny kalender med samma inställningar som den valda kalendern.",
      "duplicate_calendar_message_title": "Duplicera den här kalendern?",
      "no_calendars_found_title": "Ingen kalender hittades",
      "no_groups_in_location_title": "Inga grupper hittades",
      "delete_group_confirmation_title": "Radera den här gruppen?",
      "delete_group_confirmation": "Är du säker på att du vill ta bort den valda gruppen?",
      "delete_group_confirmation_checkbox_title": "Ta bort tillhörande kalendrar och möten",
      "delete_group_confirmation_checkbox_description": "Om du väljer det här alternativet raderas även kalendrarna i den här gruppen, tillsammans med alla möten i kalendrarna.",
      "group_status_message_title": "{status} grupp och alla associerade kalendrar?",
      "calendar_status_message_title": "{status} den här kalendern?",
      "calendar_status_message": "Du är på väg att {status} kalendern.",
      "group_status_active_message": "Är du säker på att du vill aktivera den här gruppen? Alla kalendrar i gruppen aktiveras också och blir tillgängliga för bokning.",
      "group_status_inactive_message": "Är du säker på att du vill inaktivera den här gruppen? Alla kalendrar i gruppen inaktiveras också och blir inte längre tillgängliga för bokning.",
      "coming_soon": "Kommer snart",
      "select": "Välj",
      "15mins": "15 min",
      "cancel": "Avbryt",
      "save": "Spara",
      "create": "Skapa",
      "select_calendar_group": "Välj kalendergrupp",
      "move_calendar_confirmation": "Den äldre länken slutar fungera när du fortsätter med ändringen. Bekräfta genom att markera kryssrutan.",
      "previously_called_unassigned": " (Kallades tidigare för ej tilldelad)",
      "scheduling_type": "Välj kalendertyp",
      "scheduling_type_description": "Välj en Kalendertyp för att konfigurera din kalender och Anpassa how Möte are Schemalagd.",
      "service_menu_name": "Namn på tjänstemenyn",
      "template": "Mall",
      "select_template": "Välj mall",
      "group_url": "Gruppens URL",
      "template_description": "Du kan nu välja mellan mallarna Klassisk eller Neo för gruppvyn.",
      "rooms": "Rum",
      "rooms_name": "Namn",
      "rooms_description": "Beskrivning",
      "rooms_modal_description": "Lägg till eller redigera rum.",
      "rooms_capacity": "Total kapacitet",
      "no_rooms_in_location_title": "Inga rum hittades",
      "no_rooms_in_location": "Inga rum hittades på platsen",
      "no_equipments_in_location": "Ingen utrustning hittades på platsen",
      "equipments": "Utrustning",
      "equipment_name": "Namn",
      "equipment_name_search": "Utrustningens namn",
      "equipment_description": "Beskrivning",
      "equipment_modal_description": "Lägg till eller redigera utrustning.",
      "add_equipment": "Lägg till/redigera utrustning",
      "add_room": "Lägg till/redigera rum",
      "equipment_quantity": "Totalt antal",
      "equipment_outOfService": "Antal ur drift",
      "no_equipments_in_location_title": "Ingen utrustning hittades",
      "delete_this_equipment": "Ta bort utrustningen",
      "delete_this_rooms": "Ta bort rummet",
      "delete_equipment_confirmation": "Är du säker på att du vill ta bort den här utrustningen? Det kommer också att tas bort från alla länkade kalendrar.",
      "delete_rooms_confirmation": "Är du säker på att du vill ta bort det här rummet? Det kommer också att tas bort från alla länkade kalendrar.",
      "add_new_calendar_equipments": "Lägg till ny utrustning",
      "no_equipments_found": "Din sökning gav ingen träff på någon utrustning.",
      "no_rooms_found": "Din sökning gav ingen träff på några rum.",
      "add_new_calendar_rooms": "Lägg till nytt rum",
      "rooms_disable": "Inaktivera rum",
      "equipments_disable": "Inaktivera utrustning",
      "equipments_activate": "Aktivera utrustning",
      "rooms_activate": "Aktivera rum",
      "create_equipments": "Skapa utrustning",
      "create_rooms": "Skapa rum",
      "select_calendar_rooms_title": "Välj kalender",
      "select_calendar_rooms_description": "Du kan koppla flera kalendrar till rum.",
      "select_calendar_equipments_title": "Välj kalender",
      "select_calendar_equipments_description": "Du kan välja en kalender att koppla till utrustningen.",
      "disable_equipment_title": "{status} utrustning",
      "disable_room_title": "{status} rum",
      "equipments_status_message": "Är du säker på att du vill {status} den här utrustningen?",
      "rooms_status_message": "Är du säker på att du vill {status} det här rummet?",
      "calendar_resource_disclaimer": "Detta kan påverka tillgängligheten för kopplade tjänstekalendrar.",
      "equipment_disclaimer": "Obs: Om du aktiverar utrustningen senare kommer den automatiskt att återanslutas till kalendrar som den är kopplad till",
      "room_disclaimer": "Obs: Om du aktiverar rummet senare kommer det automatiskt att återanslutas till kalendrar som det är kopplat till",
      "equipment_tab_name": "Utrustning",
      "rooms_tab_name": "Rum",
      "manage_your_rooms": "Hantera företagets rum här",
      "manage_your_equipments": "Hantera företagets utrustning här",
      "select_service_calendar_description_equipments": "Du kan välja flera tjänstekalendrar som ska kopplas till utrustning.",
      "select_service_calendar_description_rooms": "Du kan välja flera tjänstekalendrar som ska kopplas till rum.",
      "service_menus": "Tjänstemeny",
      "manage_your_calendars_groups_and_service_menus": "Hantera dina kalendrar, grupper och tjänstemenyn",
      "new_service_menu": "Skapa tjänstemeny",
      "deactivate_service_menu": "Inaktivera tjänstemeny",
      "delete_service_menu": "Ta bort den här tjänstemenyn",
      "delete_service_menu_confirmation": "Är du säker på att du vill ta bort den här tjänstemenyn?",
      "service_menu_status_message_title": "{status} den här tjänstemenyn?",
      "service_menu_status_message": "Du är på väg att {status} den här tjänstemenyn.",
      "no_service_menus_in_location_title": "Skapa din skräddarsydda tjänstemeny",
      "add_new_service_menu": "Lägg till ny tjänstemeny",
      "no_service_menus_in_location": "Börja med att skapa en ny tjänstemeny och lägg till grupper i den",
      "no_service_menu_found": "Ingen tjänstemeny hittades",
      "no_service_menu_found_desc": "Din sökning matchade inga tjänstemenyer.",
      "apply": "Tillämpa",
      "troubleshoot_calendar": "Felsök kalender",
      "round_robin_booking": "Round robin",
      "round_robin_description": "Fördelar möten mellan teammedlemmar i en roterande ordning.",
      "round_robin_example": "Exempel: Säljsamtal, onboarding-sessioner.",
      "unassigned_booking": "Evenemangskalender",
      "unassigned_description": "För att schemalägga fysiska händelser utan koppling till värd.",
      "unassigned_example": "Exempel: Konferenser, offentliga seminarier, utställningar.",
      "event_booking_alert_title": "Viktigt",
      "event_booking_alert_message": "Den här kalendertypen har viktiga skillnader.",
      "event_booking_learn_more": "Läs mer",
      "event_booking_tooltip_title": "Saker att känna till:",
      "event_booking_tooltip_content": "• Händelsekalendrar har inga användare, så möten kan inte tilldelas en användare.\n• Eftersom ingen användare är tilldelad stöds inte dynamiska verktyg för möteslänkar (Zoom, Google Meet, Microsoft Teams). För att använda onlinemöten kopierar du en statisk konferenslänk från valfritt verktyg och klistrar in den i mötesplatsen.\n• Eftersom ingen användare är tilldelad synkroniseras möten inte till en användares kalender via Kalenderinställningar → Anslutningar. Konfliktkalendrar som läggs till där tas inte med i beräkningen.\n• Möten synkroniseras endast till den kalender som valts under Extern synkronisering för den här kalendern.\n• Händelser hämtas från och skickas endast till den valda externa kalendern.\n• Endast en Google-kalender kan anslutas med extern synkronisering.",
      "class_booking": "Klassbokning",
      "class_booking_description": "En värd träffar flera deltagare.",
      "class_booking_example": "Exempel: webbseminarier, grupputbildning, onlinekurser.",
      "collective_booking": "Kollektiv bokning",
      "collective_booking_description": "Flera värdar träffar en deltagare.",
      "collective_booking_example": "Exempel: Panelintervjuer, kommittégranskningar.",
      "service_booking": "Tjänstebokning",
      "service_booking_description": "Sömlös schemaläggning för tjänstebaserade företag.",
      "service_booking_example": "Exempel: Spa-besök, reparationstjänster, konsultationer.",
      "personal_booking": "Personlig bokning",
      "personal_booking_description": "Schemalägger enskilda möten med en specifik teammedlem.",
      "personal_booking_example": "Exempel: Kundmöten, privata konsultationer.",
      "personal": "Personlig",
      "explore_more_types": "Utforska fler typer",
      "no_calendars_added": "Inga kalendrar ännu – konfigurera en!",
      "no_calendars_added_description": "Skapa din första kalender för att starta Schemalägg utan ansträngning.",
      "no_groups_added": "Inga grupper ännu – börja organisera!",
      "no_calendars_yet": "Inga kalendrar ännu",
      "no_groups_yet": "Inga grupper än",
      "no_calendars_access": "Inga kalendrar har skapats än. När en kalender har skapats visas den här. Du har inte Åtkomst för att skapa en kalender — kontakta din Admin Om behövs.",
      "no_groups_access": "Ingen Grupp har varit Konfigurera än. När en Grupp är skapad kommer den att visas här. Du har inte Åtkomst för att skapa en grupp—vänligen kontakta din Admin Om behövs.",
      "no_groups_added_description": "Använd Grupp för att Behålla dina kalendrar strukturerade. Lägg till kalendrar i en Grupp och Dela a Individ Grupp Schemaläggningslänk för enkelbokning.",
      "group_success_message": "Grupp har framgångsrikt skapats. Du can nu Inkludera-kalendrar till den här gruppen.",
      "choose_calendars": "Välj kalendrar",
      "do_it_later": "Jag gör det senare",
      "add_calendars_to_group": "Lägg till kalendrar i gruppen",
      "select_calendars_to_add": "Välj varje kalendrar Du vill Inkludera till gruppen {name}",
      "add_calendars": "Lägg till kalendrar",
      "continue": "Fortsätt",
      "conflicting_calendars": "Kalenderkonflikter",
      "conflicting_calendars_description": "Efterföljande kalendrar är redan en del av Annan Grupp. Vill du skicka dem till din Ny Grupp, <b>{name}</b>?",
      "group_associated_with": "Nuvarande Grupp",
      "move_calendar_consent": "Jag Aktivera Flyttar dessa kalendrar till Ny Grupp.",
      "calendars_moved_successfully": "varje Markerad-kalendrar har flyttats till {name}.",
      "new_group": "Ny grupp",
      "back": "Tillbaka",
      "share_otl": "Dela din Tillgänglighet varje Datum med en unik länk som Går ut Efter en bokning, vilket säkerställer Hantera Åtkomst.",
      "copied_to_clipboard": "Kopierat till urklipp",
      "generate_link": "Skapa ny länk",
      "generate_link_error": "Det gick inte att generera en engångslänk. Försök igen",
      "share_schedule_link": " Schemaläggningslänken bestäms Via Slug. Ändra Slug och Schemaläggningslänk anpassas automatiskt till ändringen.",
      "share_permanent_link": "Perfekt för Trattar, Webbplats Omdirigeringar, Eller Reklam, den permanenta länken förblir konstant, opåverkad Via Slug Dynamisk.",
      "copy": "Kopiera",
      "share_embed_code": "Lägg till denna Kod in din HTML där du vill att din {embedType} Widget ska visas.",
      "scheduling_link": "Schemaläggningslänk",
      "permanent_link": "Permanent länk",
      "one_time_link": "Engångslänk",
      "embed_code": "Bädda in kod",
      "loading": "Läser in...",
      "share_group": "Dela grupp",
      "edit_group": "Redigera grupp",
      "more_options": "Fler alternativ",
      "share_calendar": "Dela kalender",
      "edit_calendar": "Redigera kalender",
      "troubleshoot_calendar_link": "Felsök kalender",
      "calendar_config_success": "Du har konfigurerat din personliga kalender/Grupp-kalender",
      "close": " Stäng",
      "added_calendars": "Tillagda kalendrar",
      "select_calendars": "Välj kalendrar",
      "settings_confirmation": "För att Fortsätt bekräfta dessa Dynamisk.",
      "consent_checkbox_title": "Jag förstår och godkänner dessa ändringar.",
      "confirm": "Bekräfta",
      "create_group_access_disabled": "Du behöver inte Auktorisering till Skapa a Grupp. Kontakta din Admin för Åtkomst.",
      "create_calendar_access_disabled": "Du behöver inte Auktorisering för att skapa en kalender. Kontakta din Admin för Åtkomst.",
      "create_room_access_disabled": "Du har inte behörighet att hantera rum. Kontakta din administratör för åtkomst.",
      "create_equipment_access_disabled": "Du har inte behörighet att hantera utrustning. Kontakta din administratör för åtkomst.",
      "preview_booking_widget": "Förhandsgranska bokningswidget",
      "share_service_menu": "Dela tjänstemeny",
      "back_message": "Tillbaka till kalenderlistan",
      "service_calendars": "Tjänstekalendrar",
      "owned_by": "Ägs Via",
      "owned_by_anyone": "Vem som helst",
      "owned_by_me": "Jag",
      "all_groups": "Alla grupper",
      "all_calendars": "Alla kalendrar",
      "not_grouped": "Inte grupperad",
      "delete_group_desc": "Är du säker på att du vill ta bort den här gruppen? Detta kommer också att radera varje kalendrar som är Medlemmar med den här gruppen.",
      "calendar_listing_title": "Kalenderlista",
      "calendar_group_name": "Kalender-/gruppnamn",
      "success": "Framgång",
      "my_calendar": "min kalender",
      "service_calendar_description": "Smidig schemaläggning för tjänsteföretag."
    },
    "preferences": {
      "preferences": "Inställningar",
      "my_preferences": "Mina inställningar",
      "account_preferences": "Kontoinställningar",
      "user_preferences": "Användarinställningar",
      "set_preferences": "Ange inställningar för ditt konto.",
      "scheduling_options": "Schemaläggningsalternativ",
      "meeting_location": "Mötets plats",
      "zoom": "Zoom",
      "save_preferences": "Spara inställningar",
      "in_app_preferences": "Inställningar i appen",
      "set_start_day": "Ange inställningar som appens startdag",
      "view_options": "Visa alternativ",
      "services": "Tjänster",
      "feature_toggle_aria": "Växlingsknapp för funktion",
      "week_starts_on": "Veckan börjar på",
      "sunday": "Söndag",
      "widget_preferences": "Widget-inställningar",
      "set_widget_language": "Ange inställningar som widgetens språk",
      "language_and_region": "Språk och region",
      "language": "Språk",
      "english": "Engelska",
      "time_format": "Tidsformat",
      "time_format_value": "1:30 PM",
      "monday": "Måndag",
      "custom_meeting_location": "Anpassad mötesplats",
      "view_appointments_in_1": "Visa möten i",
      "timezone_uses_details_1": "Vi kommer att använda denna tidszon för att visa mötestider i hela appen och i dina mötesrelaterade e-postmeddelanden – endast för dig. Det påverkar inte din tillgänglighet eller hur andra bokar hos dig.",
      "business_timezones_1": "Företagets tidszon",
      "business_timezones_tooltip_1": "Meddelande: Genom att välja det här alternativet säkerställer du att din Inställning överensstämmer med den valda Företag Tidszonen. Om företagets tidszon ändras kommer din visningstidszon automatiskt att justeras för att matcha.",
      "recommended_timezones": "Rekommenderade tidszoner",
      "all_timezones": "Alla tidszoner"
    },
    "availability": {
      "availability": "Tillgänglighet",
      "my_availability": "Min tillgänglighet",
      "my_availability_and_booking_rules": "Tillgänglighetsschema",
      "my_availability_and_booking_rules_description": "Ange när möten kan bokas utifrån personalens tillgänglighet.",
      "account_availability": "Kontots tillgänglighet",
      "timezone": "Tidszon",
      "working_hours": "Arbetstider",
      "set_recurring_hours": "Ställ in dina återkommande arbetstider för möten",
      "select_one": "Välj en",
      "sunday": "Söndag",
      "monday": "Måndag",
      "tuesday": "Tisdag",
      "wednesday": "Onsdag",
      "thursday": "Torsdag",
      "friday": "Fredag",
      "saturday": "Lördag",
      "widget_preferences": "Widget-inställningar",
      "set_widget_language": "Ange inställningar som widgetens språk",
      "language_and_region": "Språk och region",
      "language": "Språk",
      "english": "Engelska",
      "copy_to_all": "Kopiera till alla",
      "save_availability": "Spara tillgänglighet",
      "add_time": "Lägg till tid",
      "to": "Till",
      "select_time": "Välj tid",
      "add_user": "Lägg till användare",
      "accessRestricted": {
        "header": "Åtkomst begränsad",
        "message": "Du är inte en del av det här kontot. För att få åtkomst lägger du till dig själv i det här kontot via Byråinställningar > Team > Redigera teammedlem och tilldelar kontot under ”Roller och behörigheter”.",
        "contact_admin": "Denna Sida är endast Offentlig för administratörer. Kontakta din Admin för hjälp.",
        "button_text": "Gå till byråinställningar."
      },
      "schedule": {
        "edit_schedule": "Redigera schema",
        "schedule_name": "Schemanamn",
        "schedule_name_required": "Schemanamn krävs",
        "timezone": "Tidszon",
        "timezone_placeholder": "Välj en",
        "start_time": "Starttid",
        "end_time": "Sluttid",
        "add_availability_hour": "Lägg till tillgängliga timmar",
        "remove_availability_hour": "Ta bort tillgängliga timmar",
        "unavailable": "Ej tillgänglig",
        "schedule_created": "Schemat har skapats",
        "schedule_updated": "Schemat har uppdaterats",
        "calendars_selected": "{count} kalender",
        "calendars_selected_multiple": "{count} kalendrar",
        "select_users_placeholder": "Sök efter användare",
        "edit_default_schedule": "Redigera det här schemat",
        "customize_event_type_schedule": "Anpassa endast schemat för den här kalendern",
        "multi_user_description": "Uppdatera tillgänglighet för <b>{count} valda användare</b> - {calendar}",
        "bulk_edit_warning_banner": "Bulkredigering aktiverad. Ändringarna kommer att skriva över de befintliga scheman för alla valda användare.",
        "bulk_edit_slot_applies_to_all": "Den valda tidsluckan kommer att gälla för alla valda användare.",
        "bulk_edit_slot_applies_to_selected": "Den valda tidsluckan kommer att gälla för {count} valda användare.",
        "bulk_edit_applies_to_all": "Ändringar kommer att tillämpas på alla {count} valda användare.",
        "bulk_edit_weekly_hours": "Bulkredigera veckotider",
        "bulk_edit_weekly_hours_title": "Bulkredigera veckotider",
        "bulk_edit_weekly_hours_desc": "Detta kommer att ersätta veckotiderna för alla användare listade nedan.",
        "edit_now": "Redigera nu",
        "bulk_edit": "Bulkredigera",
        "choose_days_weekly_hours": "Välj dagar för att ställa in veckotider",
        "assign_to": "Tilldela till:",
        "configure_weekly_hours": "Konfigurera veckotider",
        "selected_users": "Valda användare:",
        "bulk_edit_select_users": "Välj användare för att tillämpa",
        "bulk_edit_select_users_placeholder": "Välj teammedlemmar ...",
        "bulk_edit_select_at_least_one": "Välj minst en användare",
        "bulk_edit_editing_for": "Redigering för:",
        "bulk_edit_applies_to": "Gäller för:",
        "bulk_edit_user_count": "{count} användare",
        "bulk_edit_users_count": "{count} användare",
        "show_less": "Visa mindre",
        "more": "Mer",
        "confirm_delete": "Bekräfta radering",
        "confirm": "Bekräfta",
        "delete_user_date_confirm": "Är du säker på att du vill ta bort de datumspecifika timmarna för <b>{userName}</b> den <b>{date}</b>?",
        "delete_date_confirm": "Är du säker på att du vill radera de datumsspecifika tiderna för alla användare den <b>{date}</b>?",
        "selected_calendar": "vald kalender",
        "edit_schedule_alert": "Uppdateringar som görs här kommer att tillämpas på",
        "schedule": "Schema",
        "no_availability": "Ingen tillgänglighet",
        "date_specific_hours_show_more": "fler",
        "date_specific_hours_show_less": "färre",
        "date_specific_hours_recurring_meetings_enabled": "Det går inte att lägga till datumspecifika tider eftersom det här schemat är kopplat till en kalender där återkommande möten är aktiverat. Om du fortsätta behöver du inaktivera återkommande möten.",
        "recurring_incompatible_with_date_hours": "Återkommande möten kan inte aktiveras eftersom användarens schema innehåller datumspecifika tider, vilket är inkompatibelt.",
        "incompatible_schedule_with_recurring": "{user} schema innehåller datumsspecifika timmar, vilket inte är kompatibelt med återkommande möten.",
        "incompatible_schedule_with_recurring_calendar": "Schemat innehåller datumspecifika tider, vilket inte är kompatibelt med återkommande möten.",
        "recurring_meetings_enabled_multi_user": "Återkommande möten stöds inte för kalendrar med flera teammedlemmar eller när en teammedlem har datumspecifika tider tillagda i sitt schema.",
        "weekdays": "Vardagar, {timeRange}",
        "weekdays_hours_vary": "Vardagar, timmarna varierar",
        "weekend": "Helg, {timeRange}",
        "weekend_hours_vary": "Helg, timmarna varierar",
        "days_hours_vary": "{days}, timmarna varierar",
        "date_specific_hours_tab_name": "Datumspecifika tider",
        "date_specific_hours": "{count} datumsspecifika timmar",
        "date_specific_hours_1": "1 datumspecifik timme",
        "weekly_hours": "Veckovisa öppettider",
        "custom_schedule": "Anpassat schema",
        "select_schedule": "Välj ett schema",
        "no_schedules_found": "Inga scheman hittades",
        "untitled": "Namnlös",
        "error_updating_schedules": "Fel vid uppdatering av scheman",
        "daily": "Dagligen",
        "weekly": "Varje vecka",
        "monthly": "Varje månad",
        "custom": "Anpassad",
        "this_is_required": "Detta är nödvändigt",
        "search": "Sök",
        "edit_hours": "Redigera öppettider",
        "schedule_name_duplicate": "Ett schema med det här namnet finns redan",
        "delete_schedule_title": "Ta bort schemat \"{scheduleName}\"?",
        "delete_schedule_description": "Åtgärden kan inte ångras. Är du säker på att du vill fortsätta?",
        "delete_schedule_negative_text": "Avbryt",
        "delete_schedule_positive_text": "Ja, radera.",
        "active_on": "Aktiv på",
        "weekly_working_hours": "Veckovisa arbetstider",
        "weekly_working_hours_subtext": "Välj dagar och tider du arbetar på",
        "copy_availability_hour": "Kopiera tillgänglighet",
        "mins": "Minuter",
        "hours": "Timmar",
        "save_weekly_hours": "Spara veckotider",
        "save_date_specific_hours": "Spara datumspecifika tider",
        "update_weekly_hours_for_users": "Uppdatera veckotider för {count} användare",
        "set_date_specific_hours_for_users": "Ställ in datumsspecifika tider för {count} användare",
        "set_date_specific_hours_for_user": "Ställ in datumspecifika tider"
      }
    },
    "connections": {
      "connections": "Anslutningar",
      "connect": "ansluta",
      "conferencing": "Konferenser",
      "my_connections": "Mina anslutningar",
      "account_connections": "Kontoanslutningar",
      "connection_preferences": "Anslutningsinställningar",
      "manage_calendars_conferencing_channels": "Hantera kalendrar och konferenskanaler",
      "main_integration_calendar": "Integrerad huvudkalender",
      "event_integration_calendar": "Händelser som skapas i en systemkalender som du är en del av kommer också att skapas i den här integrerade kalendern",
      "2way_sync": "Tvåvägssynkronisering: skapa systemhändelser från händelser som bokats i den integrerade huvudkalendern",
      "calendars": "Kalendrar",
      "google": "Google",
      "outlook": "Outlook",
      "check_for_conflicts": "Kontrollera om det finns konflikter",
      "choose_accounts_to_connect": "Välj vilka konton du vill ansluta",
      "payments": "Betalningar",
      "stripe": "Stripe",
      "ads": "Annonser",
      "local_service_ads": "Annonser för lokala tjänster",
      "fire_workflow": "Aktivera arbetsflödesutlösare för händelser som bokas via tvåvägssynkronisering",
      "connect_google_outlook": "Anslut ditt konto på Google/Outlook/iCloud för att kunna välja primär kalender.",
      "execute_automation": "Kör automatisering",
      "save": "Spara",
      "lsa": "Annonser för lokala tjänster",
      "no_write_access": "Du har inte skrivbehörighet till den här kalendern",
      "connection_remove_confirmation": "Du håller på att ta bort den här integrationen",
      "active": "Aktiv",
      "icloud": {
        "title": "iCloud-integration",
        "description": "Tvåfaktorsautentisering och ett appspecifikt lösenord krävs för att ansluta ditt konto.",
        "email": "E-postadress för iCloud",
        "password": "Lösenord för iCloud",
        "connect": "Anslut",
        "cancel": "Avbryt"
      }
    }
  },
  "appointment_modal": {
    "select_a_contact": "Välj en kontakt",
    "start_time": "Starttid",
    "unassigned": "Ej tilldelad",
    "end_time": "Sluttid",
    "search_by_name_email_phone_or_company": "Sök på namn, e-post, telefon eller företag",
    "add_new": "Lägg till ny",
    "pick_from_available_contacts": "Eller välj bland tillgängliga kontakter",
    "book_appointment": "Boka möte",
    "add_blocked_off_time": "Lägg till blockerad tid",
    "recommended_timezones": "Rekommenderade tidszoner",
    "all_timezones": "Alla tidszoner",
    "calendar": "Kalender",
    "repeat": "Upprepa",
    "date_and_time": "Datum och tid",
    "close": "Stäng",
    "team_member": "Teammedlem",
    "recurring_booking": "Återkommande bokning",
    "one_slot_booking": "En tidslucka",
    "event_type": "Händelsetyp",
    "occurrences_booked": "händelser kommer att bokas",
    "repeats": "Upprepningar",
    "booking_details": "Bokningsinformation",
    "showing_slots_in_this_timezone": "Visar tidsluckor i den här tidszonen:",
    "update_contact_tz": "Uppdatera även kontaktens tidszon till",
    "date": "Datum",
    "slot": "Tidslucka",
    "calendar_default": "Kalenderstandard",
    "custom": "Anpassad",
    "meeting_notes": "(t.ex.) Mötesanteckningar för vårt kommande möte",
    "out_of_office": "(t.ex.) Borta från kontoret den här veckan!",
    "standard": "Standard",
    "appointment_title": "Titel på mötet",
    "event_title": "Händelsetitel",
    "appt_with_bob": "(t.ex.) Möte med Bob",
    "vacation": "(t.ex.) Semester",
    "show_notes": "Visa anteckningar",
    "hide_notes": "Dölj anteckningar",
    "additional_preferences": "Ytterligare inställningar",
    "meeting_location": "Mötesplats",
    "appointment_status": "Mötesstatus",
    "appt_description": "Mötesbeskrivning",
    "recurring_details": "Återkommande information",
    "event_description": "Händelsebeskrivning",
    "in_contact_timezone": "I kontaktens tidszon",
    "vacation_message": "Ska du åka på semester? Tar du lite ledigt? Blockera tid i din kalender för att förhindra kunder från att boka möten. Befintliga möten kommer fortfarande att finnas kvar i din kalender).",
    "contact": "Kontakt",
    "delete": "Radera",
    "cancel": "Avbryt",
    "back": "Tillbaka",
    "pick_available_contacts": "Eller välj bland tillgängliga kontakter",
    "no_contacts_found": "Inga kontakter hittades",
    "found": "hittades",
    "select_one": "Välj en",
    "tz_tooltip": "Detta är bara viktigt om du använder anpassade värden, till exempel appointment_start_time appointment_end_time appointment_timezone etc.. i din utgående kommunikation med dina klienter eller kunder. Det konverterar ovannämnda detaljer till personens lokala tid.",
    "meeting_location_tooltip": "Mötesplatsen kommer att ställas in som konfigurerad i kalendern.",
    "appt_meeting_location_tooltip": "Användaren kan ställa in mötesplatsen specifikt för mötet.",
    "gmeet_tooltip": "Se till att respektive teammedlem har en Google-kalender inställd som sin primära kalender.",
    "zoom_tooltip": "Se till att respektive teammedlem har Zoom integrerat.",
    "enter_meeting_location": "Ange mötesplats",
    "save_appointment": "Spara möte",
    "save_event": "Spara händelse",
    "search_contacts": "Sök på namn, e-post, telefon eller företag",
    "recurring_slots": "{recurringSlotsLength}/{count}",
    "custom_timezone": "Anpassad tidszon",
    "system_timezone": "Systemets tidszon",
    "contact_timezone": "Kontaktens tidszon",
    "account_timezone": "Kontots tidszon",
    "an_error_occurred": "Ett fel inträffade"
  },
  "popup": {
    "calendar": "Kalender",
    "appointment_owner": "Mötesägare",
    "source": "Källa",
    "booked_by": "Bokad av",
    "view_activity_log": "Visa aktivitetslogg",
    "status": "Status",
    "cancel_appointment": "Avboka möte",
    "cancel_all": "Avbryt alla",
    "google_event": "Google-händelse",
    "outlook_event": "Outlook-händelse",
    "blocked_slot": "Blockerad tidslucka",
    "appointment": "Möte",
    "confirmed": "Bekräftad",
    "unconfirmed": "Ej bekräftad",
    "cancelled": "Avbokad",
    "showed": "Deltog",
    "no_show": "Uteblev",
    "invalid": "Ogiltig",
    "more": "Mer",
    "less": "Mindre",
    "edit": "Redigera",
    "reschedule_all": "Omboka alla",
    "guests": "Gäster",
    "guest_count": "Antal gäster"
  },
  "create_calendar": {
    "calendar_name": "Kalenderns namn",
    "calendar_logo": "Kalenderns logotyp",
    "select_team_member": "Välj teammedlemmar",
    "select_single_team_member": "Välj teammedlem",
    "eg_outbound_reach": "(t.ex.) Utgående räckvidd",
    "description": "Beskrivning",
    "amount": "Antal",
    "description_placeholder": "Skriv beskrivning",
    "meeting_duration": "Mötets varaktighet",
    "meeting_location": "Mötets plats",
    "seats_per_class": "Platser per klass",
    "group": "Grupp",
    "custom_url": "Anpassad URL",
    "meeting_invite_title": "Titel för mötesinbjudan",
    "event_color": "Händelsens färg",
    "availability_type": "Tillgänglighetstyp",
    "new_calendar": "Ny kalender",
    "add_description": "Lägg till beskrivning",
    "remove_description": "Ta bort beskrivning",
    "booking_availability": "Bokningstillgänglighet",
    "slug_tooltip": "Anpassa bokningswidgetens URL.",
    "meeting_location_tooltip": "Möteslänkar visas i kalenderhändelser som ”mötesplats” och gör att du kan lägga till saker som Zoom-länkar till händelsen.",
    "advanced_settings": "Avancerade inställningar",
    "show_more_schedule": "Visa mer",
    "show_more_helper_text": "För att anpassa dina öppettider ytterligare går du till de avancerade inställningarna.",
    "reschedule_preference": "Inställningar för ombokning",
    "reschedule_preference_subtext": "Om en {contactLabel} ombokar ett möte:",
    "reassign_through_round_robin": "Tilldela om med round robin",
    "keep_same_assinged_user": "Behåll samma mötesägare",
    "new_appointment_preference": "Inställning för nya möten",
    "new_appointment_preference_text": "Boka alltid med {contactLabel}s tilldelade användare.",
    "new_appointment_preference_subtext": "Boka nya möten med {contactLabel}s tilldelade användare istället för att använda round robin-schemaläggning.",
    "cancel": "Avbryt",
    "confirm": "Bekräfta",
    "service_calendar_name": "Tjänstens namn",
    "service_logo": "Tjänstens logotyp",
    "service_select_team_member": "Välj medarbetare",
    "service_duration": "Tjänstens varaktighet",
    "appointment_invite_title": "Mötesinbjudans titel",
    "payment_placeholder": "Ange en beskrivning som kommer att visas för användaren och informera dem om betalningen",
    "deposit_amount": "Depositionsbelopp",
    "collect_deposit_amount": "Acceptera delbetalning",
    "percentage": "Procentsats",
    "total_amount": "Totalt belopp",
    "enter_meeting_location": "Ange mötesplats",
    "accept_payments": "Acceptera betalningar",
    "aria": {
      "should_accept_payment": "Bör acceptera betalning"
    },
    "calendar_name_tooltip": "Kalendernamn som ska visas på bokningswidgeten.",
    "booking_availability_tooltip": "Ange vilka dagar och tider bokningar kan göras. Det här är dina standardöppettider per vecka som visas för användare när de väljer en tid.",
    "select_team_member_tooltip": "Välj vilka teammedlemmar som ska hålla i mötet.",
    "seats_per_class_tooltip": "Ange det maximala antalet deltagare som kan boka den här klassen. När alla platser är bokade är tiden inte längre tillgänglig för bokning.",
    "meeting_color": "Konferenser Färg",
    "meeting_duration_tooltip": "Detta anger mötets längd och hur länge det pågår."
  },
  "calendar_advanced": {
    "general": {
      "quick_tip": "Snabbtips",
      "timezone_change_tip": "Tidszoner kan när som helst ändras under tidszonsinställningar",
      "save": "Spara ändringar",
      "close": "Stäng",
      "meeting_details": "Grundläggande information",
      "availability": "Tillgänglighet",
      "forms_and_payment": "Formulär och betalning",
      "notifications_and_additional_options": "Aviseringar och ytterligare alternativ",
      "connections": "Anslutningar",
      "customizations": "Anpassningar",
      "create": "Skapa",
      "edit": "Redigera",
      "equipments": "Rum och utrustning",
      "service_details": "Tjänsteinformation",
      "booking_rules": "Bokningsregler",
      "advanced_settings": "Avancerade inställningar",
      "form_and_confirmation": "Formulär & bekräftelse",
      "payments": "Betalningar",
      "notifications_and_policies": "Aviseringar och policyer",
      "widget_appearance": "Widgetutseende",
      "saving_changes": "Bara en minut — Sparar den senaste Dynamisk...",
      "calendar_id": "Kalender-ID",
      "saveCalendarSuccess": "Kalendern sparad",
      "external_sync": "Extern synkronisering",
      "booking_channels": "Bokningskanaler",
      "meeting_location": "Mötesplats",
      "staff_location": "Medarbetare och plats"
    },
    "meeting_details": {
      "meeting_location": "Mötets plats",
      "meeting_location_label": "Mötesplats",
      "enter_meeting_location": "Ange mötesplats",
      "click_to_upload": "Klicka för att ladda upp",
      "square": "Fyrkant",
      "circle": "Cirkel",
      "remove_logo": "Ta bort logotypen",
      "meeting_invite_title_tooltip": "Detta är rubriken för kalendermötet som visas i din listvy för möten, kalendervy och tredjepartskalendrar.",
      "event_color_tooltip": "Välj en färg för bokningshändelsen. Färgerna synkroniseras med händelser i Google Kalendrar.",
      "enter_a_name": "Ange ett namn.",
      "enter_an_event_title": "Ange en titel på händelsen.",
      "high_priority": "Hög prioritet",
      "medium_priority": "Medelhög prioritet",
      "low_priority": "Låg prioritet",
      "priority": "Prioritet",
      "custom": "Anpassad",
      "zoom_not_added": "Användaren har inte anslutit sitt Zoom-konto ännu.",
      "opt_avail": "Optimera för tillgänglighet",
      "opt_equal": "Optimera för jämn fördelning",
      "team_members": "Välj teammedlemmar",
      "team_members_location": "Välj medarbetare och tilldela mötesplats",
      "team_member": "Välj teammedlem",
      "team_member_location": "Välj medarbetare och tilldela mötesplats",
      "meeting_location_required": "Mötesplats krävs.",
      "meeting_details": "Grundläggande information",
      "meeting_details_description": "Grundläggande information som används för att identifiera den här kalendern.",
      "or_drag_and_drop": "eller dra och släpp",
      "service_details": "Tjänsteinformation",
      "team_member_disabled_recurring_tooltip": "Återkommande möten fungerar endast för en teammedlem. Om du vill lägga till flera teammedlemmar behöver du inaktivera återkommande möten.",
      "team_member_disabled_class_booking_tooltip": "Endast en teammedlem kan läggas till i en klassbokningskalender.",
      "advanced_settings": "Avancerade inställningar",
      "enable_contact_assigned_to_setting": "Om du vill aktivera den här inställningen måste formuläret vara först i widgetordningen. Ändra widgetordningen från fliken Formulär och betalning.",
      "reschedule_preference_setting_tooltip": "Välj vem mötet ska tilldelas när en {contactLabel} bokas om från Bokningswidgeten.",
      "appointment_preference_tooltip": "Välj om nya möten alltid ska bokas med {contactLabel}s tilldelade användare. Om en {contactLabel} har en tilldelad användare kommer den användaren att få företräde, annars kommer tilldelningen att ske enligt principen \"round robin\". Tips: Stäng av ”Tillåt val av medarbetare” för att förhindra att bokare byter medarbetare i bokningswidgeten.",
      "add_location": "Lägg till plats",
      "multiple_locations_neo": "Erbjud flera platsalternativ som den som bokar kan välja mellan. Flera platser stöds endast av Neo-widgeten.",
      "make_owner": "Gör till ägare",
      "only_one_team_member": "Endast en teammedlem tillåts när flera platser läggs till.",
      "ask_the_booker_error_message": "Platsen för Fråga bokaren finns redan.",
      "enter_location": "Ange platsvärde",
      "enter_display_label": "Ange visningsetikett",
      "add_display_label": "Lägg till visningsetikett",
      "multiple_location_support_message": "Erbjud flera platsalternativ som den som bokar kan välja mellan. Flera platser stöds endast av Neo-widgeten.",
      "only_one_team_member_personal_calendar": "Endast en teammedlem tillåts för personlig bokning. ",
      "ms_teams_not_added": "Användaren har inte anslutit sitt Microsoft Teams-konto ännu.",
      "enable_new_appt_preference": "Aktivera inställning för nya möten",
      "enable_new_appt_preference_desc": "Genom att aktivera &quot;<b>Boka alltid med {contactLabel}s tilldelade användare</b>&quot; kommer <b>Formuläret</b> automatiskt att ställas in som det första steget i widgetordningen.",
      "location_exists_toast": "Konferenser Plats har redan lagts till",
      "not_supported_with_multiple_team_members": "Stöds inte med flera teammedlemmar",
      "not_supported_personal_calendar": "Stöds inte i personlig kalender",
      "not_supported_class_booking": "Stöds inte i kursbokningskalendern",
      "not_supported_collective_booking": "Stöds inte i den gemensamma kalendern",
      "not_supported_service_booking": "Stöds inte i tjänstekalendern",
      "not_supported_round_robin": "Stöds inte i Round Robin-kalendern",
      "not_supported_event": "Stöds inte i händelsekalendern",
      "calendar_logo_tooltip": "Välj en logotyp som ska visas på bokningswidgeten.",
      "calendar_name_tooltip": "Kalendernamn som ska visas på bokningswidgeten.",
      "description_tooltip": "Beskriv vad kalendern gäller. Texten visas i bokningswidgeten.",
      "group_tooltip": "Du kan tilldela den här kalendern till en grupp (om en sådan har skapats). Användare som öppnar grupplänken kan bläddra bland och boka från alla kalendrar i gruppen.",
      "custom_url_tooltip": "Anpassa bokningswidgetens URL.",
      "meeting_color_tooltip": "Välj en färg för bokningshändelsen. Färgerna synkroniseras med händelser i Google Kalendern.",
      "add_display_label_tooltip": "Dölj den faktiska platsen och visa en anpassad etikett tills mötet är bokat (gäller när flera platser har lagts till).",
      "meeting_location_tooltip": "Välj en plats eller välj Anpassad för att lägga till en valfri adress eller möteslänk.",
      "team_members_location_tooltip": "Välj den medarbetare som ska hålla i mötet och ange mötesplats.",
      "meeting_distribution": "Mötesfördelning",
      "meeting_distribution_tooltip": "Välj hur möten ska tilldelas medarbetare.",
      "opt_avail_tooltip": "Tilldela möten till den medarbetare som är tillgänglig vid den valda tiden, oavsett tidigare bokningar. Maximerar utnyttjandet av lediga tider och ökar bokningsgraden.",
      "opt_equal_tooltip": "Fördela möten jämnt mellan alla medarbetare genom att ta hänsyn till tidigare bokningar. Prioriterar rättvisa framför tillgänglighet.",
      "priority_tooltip": "Ange prioritetsnivå för tilldelning av möten när flera medarbetare är tillgängliga. Medarbetare med högre prioritet beaktas först vid bokningar, följt av medelhög och låg prioritet.",
      "contact_routing_preference": "Inställningar för vidarekoppling",
      "contact_routing_preference_tooltip": "Ange hur nya och återkommande {contactsLabel} tilldelas medarbetare – antingen via round robin eller till sin ursprungliga ägare.",
      "team_members_location_owner_tooltip": "Huvudanvändaren som äger mötet och anger den slutliga mötesplatsen.",
      "owner": "Ägare",
      "upload_from_system": "Ladda upp från systemet",
      "choose_from_media_storage": "Välj från mediebiblioteket",
      "only_one_team_member_allowed": "Endast en teammedlem tillåts.",
      "at_least_two_team_members_required": "Minst två teammedlemmar krävs.",
      "at_least_one_team_member_required": "Minst en teammedlem krävs.",
      "widget_shape": "Widgetens form:",
      "widget_bookings_path": "/widget/bokningar/",
      "contact_name_placeholder": "&#123;&#123; contact.name &#125;&#125;",
      "profile_photo_alt": "profilfoto",
      "meeting_location_placeholder": "Mötesplats",
      "team_member_meeting_location": "Medarbetare och mötesplats",
      "meeting_location_desc": "Tilldela medarbetare till den här kalendern och ange var möten hålls.",
      "event_calendar_meeting_location_desc": "Välj var mötet ska äga rum."
    },
    "meeting_location": {
      "ask_the_booker": "Fråga bokaren (bokaren går in på platsen)",
      "ask_the_booker_desc": "Den som bokar ombeds ange en valfri mötesplats vid bokning",
      "zoom": "Zoom",
      "google_meet": "Google Meet",
      "microsoft_teams": "Microsoft Teams",
      "phone": "Telefon",
      "full_address": "Fullständig adress",
      "custom": "Anpassad",
      "meeting_location": "Mötesplats"
    },
    "availability": {
      "my_availability": "Min tillgänglighet",
      "calendar_availability": "Kalenderns tillgänglighet",
      "calendar_availability_desc": "Ange när möten kan bokas i den här kalendern.",
      "set_availability": "Ställ in din tillgänglighet för kalendern här.",
      "standard": "Standard",
      "custom": "Anpassad",
      "to": "Till",
      "copy_to_all": "Kopiera till alla",
      "add_time": "Lägg till tid",
      "recurring_meeting": "Återkommande möte",
      "recurring_info": "Endast en användare per kalender för återkommande bokning.",
      "repeat": "Upprepa",
      "times_to_repeat": "Antal upprepningar",
      "slots_unavailable": "Om tidsluckor inte är tillgängliga?",
      "overlap_status": "Mötesstatus för överlappande tidsluckor ",
      "meeting_interval": "Mötesintervall",
      "meeting_duration": "Mötets varaktighet",
      "minimum_scheduling": "Minsta varsel för schemaläggning",
      "date_range": "Datumintervall",
      "count_available_days_only": "Räkna endast tillgängliga dagar",
      "count_available_days_only_tooltip": "Hoppar över dagar utan konfigurerad tillgänglighet. Om du till exempel har stängt på helgerna kommer ett 2-dagarsintervall på fredag att utvidgas till att omfatta måndag och tisdag.",
      "maximum_bookings_per_day": "Max antal bokningar per dag",
      "maximum_bookings_per_slot": "Max antal bokningar per tidslucka",
      "maximum_bookings_per_slot_per_user": "Max antal bokningar per tidslucka (per användare)",
      "seats_per_class": "Platser per klass",
      "pre_buffer_time": "Bufferttid före",
      "post_buffer_time": "Bufferttid efter",
      "pre_buffer_tooltip": "Bufferttid före är ytterligare tid som kan läggas till före ett möte, vilket ger extra tid för förberedelser.",
      "post_buffer_tooltip": "Bufferttid efter är ytterligare tid som kan läggas till efter ett möte, vilket ger extra tid för avrundning och sammanställning.",
      "buffer_time": "Bufferttid",
      "daily": "Dagligen",
      "weekly": "Varje vecka",
      "monthly": "Varje månad",
      "skip_booking": "Hoppa över bokning av otillgängliga tidsluckor",
      "continue_booking": "Fortsätt boka",
      "book_next_available": "Boka nästa lediga tidslucka",
      "confirmed": "Bekräftad",
      "unconfirmed": "Ej bekräftad",
      "enter_valid_hours": "Ange giltiga öppettider",
      "enter_valid_avail": "Ange giltig anpassad tillgänglighet",
      "availability_type_tooltip": "Välj Standardtillgänglighet för vanliga bokningar som erbjuds varje vecka. Välj Anpassad för bokningar som endast är gäller specifika datum.",
      "meeting_interval_tooltip": "Styr hur ofta bokningsbara tider visas.\nFör ett 30-minutersmöte:\n • Välj 1 timme för att visa tider vid varje hel timme. \n• Välj 30 minuter för att visa tider var 30:e minut.",
      "date_range_tooltip": "Händelser kan schemaläggas under de kommande n dagarna.",
      "maximum_bookings_per_day_tooltip": "Maximalt antal möten per dag i den här kalendern.",
      "maximum_bookings_per_slot_tooltip": "Begränsa hur många möten en användare kan ta emot under samma tid. Om gränsen nås tilldelas bokningen nästa användare i round-robin-kön, eller så blir tiden otillgänglig.",
      "add_days": "Lägg till dagar",
      "month_on_day": "Månadsvis på dag",
      "month_on_last_day": "Månadsvis på föregående dag",
      "day": "Dag",
      "week": "Vecka",
      "month": "Månad",
      "mins": "Minuter",
      "hours": "Timmar",
      "days": "Dagar",
      "weeks": "Veckor",
      "months": "Månader",
      "meeting_interval_error": "Mötesintervallet måste vara mellan 5 minuter och 12 timmar.",
      "meeting_duration_error": "Mötets varaktighet måste vara mellan 1 min och 12 timmar.",
      "buffer_time_error": "Bufferttiden måste vara mindre än 12 timmar.",
      "appointment_interval": "Mötesintervall",
      "appointment_duration": "Mötets varaktighet",
      "maximum_appointments_per_day": "Max antal möten per dag",
      "subTitle": "Välj datum för att ställa in specifika tider.",
      "heading_1": "Tillgängliga timmar per vecka",
      "scheduling_availability_heading": "Bokningstillgänglighet",
      "scheduling_availability_tooltip": "Använd ett befintligt tillgänglighetsschema eller skapa ett anpassat schema för den här kalendern.",
      "tooltip_1": "Ställ in ditt tillgänglighetsschema per vecka. Detta är dina standardtimmar som kommer att tillämpas konsekvent på veckobasis.",
      "heading_2": "När är du tillgänglig?",
      "unavailable_label": "Ej tillgänglig",
      "tooltip_2": "Justera ditt schema för specifika datum. Åsidosätt dina vanliga veckotimmar genom att markera tillgänglig eller ej tillgänglig för valda datum.",
      "date_specific_level": "Lägg till datumspecifika timmar",
      "specific_hours_button": "Datumspecifika timmar",
      "specific_hours_description": "Ange anpassad tillgänglighet för specifika datum som avviker från ditt veckoschema.",
      "overlap_error": "Tidsluckor kan inte överlappa varandra",
      "apply": "Tillämpa",
      "copy_times_to": "Kopiera tider till",
      "no_date_specific_heading": "Ingen datumspecifik tid har lagts till.",
      "no_date_specific_description": "Du kan lägga till/ta bort specifikt datum och tid i din tillgänglighet.",
      "recurring_disabled_conditions_tooltip": "Återkommande möten är Inaktiverad. För att utlösa dem ser du till att kalendern bara har en Grupp Medlemmar och att den inte har lagts till datumspecifik timme Eller Ofullständig betalning.",
      "date_specific_hours_disabled_conditions_tooltip": "För att inkludera en datumspecifik timme ser du till att återkommande möten är avstängda.",
      "recurring_disable_event_calendar_conditions": "Återkommande möten är Inaktiverad. För att utlösare dem se till att ingen datumspecifik timme Eller Ofullständig betalning läggs till.",
      "service_duration": "Tjänstens varaktighet",
      "service_interval": "Tjänsteintervall",
      "service_interval_tooltip": "Mötesintervallet anger hur ofta bokningsbara tidsluckor visas i kalendern. Till exempel, för ett evenemang på 30 minuter innebär ett intervall på 1 timme att tidsluckor visas varje timme. Ett intervall på 30 minuter innebär att tidsluckor visas var 30:e minut.",
      "service_duration_tooltip": "Detta anger längden på ditt möte och avgör hur länge det kommer att pågå.",
      "minimum_scheduling_tooltip": "Här anges den minsta tid som krävs för att boka ett möte via kalenderwidgeten. Exempel: om det är inställt på 4 timmar kan möten inte bokas inom 4 timmar från deras starttid. Bokningar måste göras minst 4 timmar i förväg.",
      "look_busy_title": "Se upptagen ut",
      "look_busy_helper_text": "Dölj en procentandel av dina tillgängliga tider i bokningswidgeten för att framstå som mer upptagen och efterfrågad.",
      "look_busy_percentage_description": "Dölj antalet tillgängliga tidsluckor med x %.",
      "maximum_bookings_per_slot_tooltip_personal": "Maximalt antal möten som tillåts under samma tid.",
      "enable_recurring_title": "Aktivera återkommande möte",
      "enable_recurring_desc": "Om du aktiverar <b>återkommande möten</b> inaktiveras följande inställningar automatiskt, eftersom de inte kan samexistera:",
      "date_specific_hours": "Alla <b>datumspecifika tider</b> kommer att tas bort.",
      "multiple_team_members": "<b>Flera teammedlemmar</b> kommer att tas bort – endast en teammedlem kan finnas kvar i den här kalendern.",
      "partial_payments": "<b>Ofullständig Betalningar</b> kommer att vara Inaktiverad och Full beloppet kommer att tas ut.",
      "select_team_member_to_keep": "Välj en Grupp Medlemmar till Behåll in den här kalendern:",
      "select_team_member": "Välj teammedlem",
      "partial_payments_disabled": "Eftersom delbetalningar kommer att inaktiveras, hur vill du få hela beloppet för återkommande möten?",
      "enable_date_specific_hours": "Aktivera datumspecifika tider",
      "enable_date_specific_hours_desc": "Om du aktiverar <b>datumspecifika tider</b> inaktiveras följande inställning automatiskt, eftersom de inte kan samexistera:",
      "recurring_meetings_disabled": "<b>Återkommande möten kommer att inaktiveras</b>, {contactsLabel} kommer endast att kunna boka enstaka möten baserat på de tillgängliga datumen du ställer in.",
      "payment_preference": "Betalningsinställning:",
      "team_members_in_this_calendar": "Teammedlemmar i den här kalendern",
      "other_team_members": "Andra teammedlemmar (inte tillagda i denna kalender)",
      "select_team_member_tooltip": "Välj vilka teammedlemmar som ska hålla i mötet.",
      "meeting_duration_tooltip": "Detta anger mötets längd och hur länge det pågår.",
      "date_specific_hours_tooltip": "Justera ditt schema för specifika datum. Åsidosätt dina vanliga veckotimmar genom att markera tillgänglig eller ej tillgänglig för valda datum.",
      "recurring_meeting_tooltip": "Tillåt att möten upprepas flera gånger under en tidsperiod.",
      "repeat_frequency_tooltip": "Välj frekvens för den här återkommande händelsen.",
      "time_to_repeat_tooltip": "Ange totalt antal upprepningar.",
      "slots_unavailable_tooltip": "Välj vad som ska hända om en eller flera tidsluckor i en återkommande bokning redan är bokade.",
      "skip_booking_tooltip": "Endast tillgängliga tidsluckor bokas. Otillgängliga datum i den återkommande serien hoppas över.",
      "force_book": "Force Book",
      "force_booking_tooltip": "Alla tidsluckor bokas, även om det finns en konflikt. Använd med försiktighet för att undvika dubbelbokning.",
      "book_next_available_tooltip": "Om en vald tidslucka inte är tillgänglig bokas nästa tillgängliga tidslucka enligt samma återkommande schema (t.ex. nästa måndag om det är veckovis).",
      "slot_interval_tooltip": "Ställ in mellanrummet mellan starttiderna för på varandra följande tillgängliga tidsluckor. Om mötet till exempel är 30 minuter långt och du anger intervallet till 60 minuter kan en användare boka en tidslucka kl. 09:00, sedan kl. 10:00 och så vidare – även om varje möte bara pågår i 30 minuter.",
      "minimum_scheduling_notice_tooltip": "Kräv att användare bokar möten minst så här långt i förväg.",
      "date_range_preferences_tooltip": "Ange hur långt fram i tiden bokningar kan göras från dagens datum.",
      "maximum_bookings_per_slot_preferences_tooltip": "Begränsa hur många möten som kan schemaläggas för samma tidslucka.",
      "maximum_bookings_per_slot_per_user_preferences_tooltip": "Begränsa hur många möten som kan schemaläggas för samma tidslucka (per användare).",
      "pre_buffer_time_tooltip": "Tid att blockera före varje möte, så att det finns extra tid för förberedelser.",
      "post_buffer_time_tooltip": "Tid att blockera efter varje möte, så att det finns extra tid för att avsluta.",
      "seats_per_class_tooltip": "Ange det maximala antalet deltagare som kan boka den här klassen. När alla platser är bokade är tiden inte längre tillgänglig för bokning.",
      "maximum_bookings_per_slot_per_user_tooltip": "Begränsa hur många möten som kan schemaläggas för samma tidslucka (per användare).",
      "repeat_frequency": "Upprepningsfrekvens",
      "slot_interval": "Intervall för tidsluckor",
      "skip_booking_helper_text": "Endast tillgängliga tidsluckor bokas. Otillgängliga datum i den återkommande serien hoppas över.",
      "force_book_helper_text": "Alla tidsluckor bokas, även om det finns en konflikt. Använd med försiktighet för att undvika dubbelbokning.",
      "book_next_available_helper_text": "Om en Markerad Tidslucka är inte tillgänglig, Boka den Nästa tillgängliga Tidslucka På samma Återkommande schema (t.ex. Nästa Måndag Om varje vecka).",
      "bulk_edit": "Bulk-redigering",
      "select_users": "Välj användare",
      "select_all": "Välj alla",
      "times_to_repeat_tooltip": "Ange totalt antal upprepningar.",
      "custom_recurrence": "Anpassad upprepning",
      "repeats_every": "Upprepas varje",
      "availability_schedule": "Tillgänglighetsschema",
      "availability_schedule_desc": "Ange när möten kan bokas utifrån medarbetarnas tillgänglighet.",
      "no_users_added": "Inga medarbetare har lagts till!",
      "no_users_added_description": "Lägg till medarbetare för att kontrollera deras tillgänglighet.",
      "add_users": "Lägg till medarbetare",
      "minimum_scheduling_notice_error": "Ange ≤ 1 440 min.",
      "please_select_date": "Välj ett datum för att fortsätta"
    },
    "forms_payment": {
      "forms": "Formulär och gäster",
      "forms_sub": "Konfigurera inställningar för den sista sidan som visas efter en lyckad bokning.",
      "select_form": "Välj formulär",
      "enable_same_user_assignment": "Tilldela kontakter till respektive teammedlem i kalendern varje gång ett möte bokas.",
      "sticky_contacts_label": "Fäst {contactsLabel}",
      "sticky_contacts": "Fyll i fält i förväg",
      "confirmation_page": "Bekräftelsesida",
      "default": "Standard",
      "redirect_url": "URL för omdirigering",
      "use_custom_form_rules": "Använd anpassade formulärregler",
      "default_message_tooltip": "Visar det konfigurerade bekräftelsemeddelandet efter att mötet har bokats.",
      "redirect_url_tooltip": "Omdirigerar kunden till den angivna sidan efter att mötet har bokats.",
      "use_custom_form_rules_tooltip": "Använder omdirigeringen eller det anpassade meddelandet som definieras i det anpassade formuläret. Om ingen regel gäller visas kalenderns bekräftelsemeddelande.",
      "thank_you": "Tack för ditt meddelande",
      "enter_url": "Ange URL",
      "enter_thank_you_message": "Ange ett tackmeddelande.",
      "amount_tab_hidden_label": "Platshållare för beloppsflik",
      "percentage_tab_hidden_label": "Platshållare för procentsatsflik",
      "pixel_id": "Meta –Id (Valfritt)",
      "auto_confirm": "Automatisk bekräftelse av nya kalendermöten",
      "configure_payment": "Konfigurera betalningsalternativ",
      "accept_payments": "Acceptera betalningar",
      "test": "Test",
      "live": "Live",
      "enable_guests": "Lägg till gäster",
      "add_guest_tooltip": "Med tillägg av gäster kan deltagaren lägga till flera deltagare till samma möte.",
      "add_guest_custom_form_tooltip": "Om du aktiverar det här alternativet skickas ett systemgenererat e-postmeddelande till gästerna med en länk till det anpassade formuläret när deras möte har bekräftats. För att undvika dubbla e-postmeddelanden ser du till att ett separat bekräftelsemeddelande inte redan har konfigurerats för gästerna. (Verifiera detta på fliken Aviseringar > Bekräftelseavisering).",
      "add_guest_same_form_check": "Skicka samma formulär för att samla in information via e-post till alla gäster.",
      "payment_tooltip": "Betalning gäller endast för huvuddeltagaren och inte för gästerna.",
      "default_form": "Standard (förnamn, efternamn, e-post, telefon, anteckningar)",
      "select_form_tooltip": "Om du vill samla in mer information än standardvärdena (förnamn, efternamn, e-post och telefon) från personer som bokar i den här kalendern skapar du ett anpassat formulär i Webbplatser > Formulär > Byggverktyg och välj sedan formuläret via rullgardinsmenyn nedan.",
      "confirmation_page_tooltip": "När någon gör en bokning kan du välja att visa ett anpassat meddelande på samma sida (Standard) eller omdirigera dem till en sida som du väljer (Omdirigera).",
      "add_guest_collect_email": "Namn och e-post",
      "add_guest_count_only": "Endast antal",
      "custom_email_notification": "Skicka anpassat formulär till gäster.",
      "consent_label": "Kryssruta för samtycke",
      "consent_input_placeholder": "Lägg till samtyckestext",
      "same_user_assignment_tooltip": "För att aktivera den här inställningen måste formuläret vara först på widgeten. Ordna om widgeten så att formuläret placeras först för att aktivera den här inställningen.",
      "consent_tooltip": "Be kontakter om att ge sitt samtycke när de bokar ett möte.",
      "stripe_error": "Upp till två decimaler (exempel: 25,99)",
      "auto_confirm_service": "Automatisk bekräftelse av nya möten",
      "service_form_message": "Om en kontakt bokar flera tjänster kommer de bara att se standardformuläret i tjänstemenyn.",
      "deposit_amount_error": "Depositionsbeloppet måste vara mindre än det totala beloppet.",
      "deposit_percentage_error": "Procentsatsen för deposition måste vara mindre än 100 %.",
      "partial_payment_tooltip": "Aktivera delbetalningar för att ta ut depositionsbelopp från kunder under bokningsprocessen.",
      "partial_payment_enable_error": "Det totala beloppet som anges måste vara större än 0 för att möjliggöra delbetalningar.",
      "payment_disable_text_integration": "Integrera en betalningsleverantör under Betalningar > Integrationer för att börja ta emot betalningar",
      "payment_disable_text_recurring": "Alternativet Acceptera betalning är inte tillgängligt för återkommande möten. Stäng av återkommande möten för att aktivera betalningar.",
      "date_and_time_selector": "Datum- och tidsväljare",
      "form_selector": "Formulär",
      "order_step": "Steg",
      "widget_order_label": "Widgetordning",
      "widget_order_tool_tip": "Ändra ordningen på ”Datum- och tidsväljare” och ”Formulär” i kalenderwidgeten. Du behöver bara dra och ordna om efter dina önskemål.",
      "widget_re_order_tooltip": "Det går endast att ordna om med widgetstilen Neo. Byt till Neo för att ordna om.",
      "widget_re_order_disabled_tooltip": "För att ordna om widgetordningen behöver du inaktivera ”Inställning för nya möten (boka alltid med {contactLabel}s tilldelade användare)” från avsnittet i Mötesinformation > Gruppmedlemmar > Avancerade inställningar.",
      "payment_description_error": "Högsta teckengräns på 1 000 har uppnåtts.",
      "widget_multiple_location_disabled_tooltip": "Klassisk widget har inte stöd för flera mötesplatser. .Ta bort eventuella ytterligare platser för att använda den klassiska widgeten",
      "recurring_payment_label": "Återkommande mötesbetalning",
      "enable_payments_for_guests": "Aktivera betalningar för gäster",
      "guest_payment_description": "Eftersom Du've Aktiverad alternativet ”Lägg till gästerna” kan du även välja till avgift per Gäst När av bokning.",
      "charge_per_attendee": "Avgift per deltagare",
      "charge_per_attendee_description": "Multiplicera det totala beloppet Via siffra av deltagarna (inklusive gäster) tar ut betalning vid bokning.",
      "click_confirm_description": "Klicka på spara för att tillämpa ändringarna.",
      "multiply_amount_guests": "Ta ut betalning för varje deltagare",
      "multiply_amount_guests_description": "När detta är aktiverat multipliceras beloppet som ska tas ut vid bokning med det totala antalet deltagare, inklusive gäster.",
      "first_appointment_only": "avgift endast för första Möte",
      "all_appointments": "avgift för varje Möte upfront",
      "no_payment_provider_connected": "Ingen betalningsleverantör ansluten.",
      "no_default_payment_provider": "Ingen betalning Leverantör ansluten",
      "provider_not_supported": "Standard Leverantör stöds inte",
      "manage_payment_provider": "Hantera betalningsleverantörer",
      "supported_providers": "Stödda leverantörer",
      "paypal_razorpay_helper_text": "Betalningar kommer endast att behandlas via Razorpay, eftersom PayPal inte stöds med anpassade leverantörer.",
      "rearrange_widget_order": "Ändra ordning på widgetar",
      "change_form_order": "Dynamiska Formulären till den andra stegen in Widget kommer att Inaktivera the Efterföljande Inställning:",
      "change_form_order_desc": "<b>Inställning för nya möten (Boka alltid med {contactLabel}s tilldelade användare)</b> kommer att inaktiveras. Detta innebär att möten kan bokas med vilken tillgänglig gruppmedlem som helst, istället för att vara begränsade till {contactLabel}s tilldelade användare.",
      "enable_mandatory_guest": "Skapa lägger till minst en Gäst Krävs. Gäst Fält kommer att föröppnas och måste fyllas i Före bokning.",
      "enable_mandatory_guest_count": "Kräv att antal gäster anges i bokningswidgeten.",
      "require_guest_for_booking": "Kräv gäster för bokning",
      "sticky_contacts_tooltip": "Fyll i Fält automatiskt för kända {contactsLabel}.",
      "auto_confirm_tooltip": "Markera automatiskt nya möten som bekräftade utan att kräva manuell godkännande. Inaktivera detta om du vill granska och bekräfta varje bokning manuellt innan den schemaläggs.",
      "confirm_tooltip": "När någon gör en bokning kan du välja att visa ett anpassat meddelande på samma sida (Standard) eller omdirigera dem till en sida som du väljer (url för omdirigering).",
      "facebook_pixel_id_tooltip": "",
      "accept_payments_tooltip": "Aktivera betalningsinsamling vid bokningar.",
      "total_amount_tooltip": "Ange mötets totala avgift.",
      "deposit_amount_tooltip": "Belopp som samlas in vid bokning som deposition.",
      "multiply_amount_guests_all_guests": "Ta ut betalning för varje deltagare, inklusive gäster",
      "multiply_amount_guests_all_guests_tooltip": "När detta är aktiverat multipliceras beloppet som ska tas ut vid bokning med det totala antalet deltagare, inklusive gäster.",
      "payment_description": "Betalningsbeskrivning",
      "payment_description_desc": "Visas för den som bokar när betalningsuppgifter anges.",
      "payment_description_tooltip": "Lägg vid behov till information som kan vara till hjälp om betalningen.",
      "test_mode_warning": "Testläge Dynamisk – ingen riktig Försäljning kommer att behandlas.",
      "pixel_id_tooltip": "Skicka aktivitet i bokningswidgeten, som visningar, klick och inskickningar, till Meta med hjälp av ditt pixel-ID.",
      "forms_description": "Ange dina preferenser och inställningar för insamling av kundinformation under bokningar.",
      "payment_mode": "Betalningssätt",
      "payment_mode_tooltip": "Växla mellan Testläge och Live -läge för betalningar. in Testläge görs ingen riktig fakturering — använd den för att simulera bokningen och betalningen Arbetsflöde. Byt till Live -läge för att ta emot faktiska betalningar Från Kunder.",
      "enable_coupon": "Aktivera kupongkoder",
      "enable_coupon_tooltip": "Tillåt kunderna att använda kupongkoder under bokningen. För att säkerställa att de fungerar skapar du först giltiga kuponger under Betalningar > Kupongkoder.",
      "guests": "Gäster"
    },
    "notifications": {
      "third_party_cal": "Inställningar för tredjepartskalender",
      "third_party_cal_desc": "Konfigurera dina inställningar för tredjepartskalendrar.",
      "additional_settings": "Ytterligare inställningar",
      "additional_settings_desc": "Konfigurera ytterligare inställningar för din kalender.",
      "notifications": "Aviseringar",
      "notifications_sub": "Konfigurera hur du skickar bokningsaviseringar via e-post, SMS, WhatsApp och aviseringar i appen.",
      "edit": "Redigera",
      "created_on": "Skapad den",
      "updated_on": "Uppdaterad den",
      "delivered": "Levererad",
      "not_available": "N/A",
      "select_notification_type": "Välj typ av avisering.",
      "notification_person": "Vem ska få den här aviseringen?",
      "contact": "{contactLabel}",
      "guest": "Gäst",
      "assigned_user": "Tilldelad användare",
      "emails": "E-postmeddelanden",
      "alert_email_address": "Informera e-postadress",
      "ack_email": "Bekräftelsemejl",
      "send_google_invites": "Tillåt att Google-kalendern skickar inbjudnings- eller uppdateringsmejl till deltagare.",
      "assign_user_to_contact_desc": "När det är aktiverat kommer {contactLabel}s tilldelade användare att matcha ägaren till mötet med den senaste ändringen – oavsett om det har bokats, ombokats eller tilldelats om.",
      "send_google_outlook_invites": "Tillåt att Google-/Outlook-/iCloud-kalendern skickar inbjudningar och uppdateringsmejl till deltagare.",
      "assign_user_to_contact": "Tilldela {contactsLabel} till respektive teammedlem i kalendern varje gång ett möte bokas.",
      "skip_assigning_user_to_contact": "Hoppa över att tilldela {contactLabel} om {contactLabel} redan har en tilldelad användare.",
      "skip_assigning_user_to_contact_desc": "När funktionen är aktiverad kommer {contactLabel}s tilldelade användare att förbli densamma, även om mötets ägare är en annan.",
      "assigned_staff": "Tilldelad medarbetare",
      "additional_emails": "Ytterligare e-postmeddelanden",
      "assign_user_to_staff": "Tilldela alltid kontakten till ägaren av mötet.",
      "allow_cancellation": " Tillåt avbokning av möte",
      "allow_reschedule": "Tillåt ombokning av möte",
      "allow_cancellation_tooltip": "När det är aktiverat läggs det till en avbokningslänk i avsnittet med ytterligare anteckningar och den inkluderas i kalenderinbjudan. Länken kommer sluta att gälla enligt angivna inställningar före mötets starttid, vilket förhindrar bokaren från att avboka mötet.",
      "allow_reschedule_tooltip": " När det är aktiverat läggs det till en länk för ombokning i avsnittet med ytterligare anteckningar och den inkluderas i kalenderinbjudan. Länken kommer sluta att gälla enligt angivna inställningar före mötets starttid, vilket förhindrar bokaren från att boka om mötet.",
      "cancellation_link_expiry": "Avbokningslänken upphör att gälla",
      "reschedule_link_expiry": "Ombokningslänken upphör att gälla",
      "before_meeting": "före mötet",
      "cancellation_and_reschedule_policy": "Avboknings- och ombokningspolicy:",
      "meeting_invite_notes": "Anteckningar för mötesinbjudan",
      "meeting_invite_notes_tooltip": "Lägg till anteckningar som visas i kalenderinbjudan som skickas till kunder. Anteckningarna synkroniseras till tredjepartskalendrar i mötesbeskrivningen."
    },
    "connections": {
      "connections_heading": "Synkronisering med extern kalender",
      "booking_channels_heading": "Bokningskanaler",
      "booking_channels_description": "Konfigurera hur den här kalendern tar emot bokningar från externa plattformar.",
      "connections_sub": "Synkronisera möten med externa kalendrar och hantera hur händelser behandlas.",
      "link_to_calendar": "Länk till kalender",
      "sync_option": "Synkroniseringsalternativ",
      "execute_automation": "Kör automatisering",
      "fire_workflow": "Aktivera arbetsflödesutlösare för händelser som bokas via tvåvägssynkronisering.",
      "reserve_with_google": "Boka med Google [Föråldrad]",
      "reserve_with_google_setup": "Visa installationsanvisningar",
      "reserve_with_google_configure": "Konfigurera",
      "change": "Ändra",
      "rwg_deprecation_notice": "Google har fasat ut <b>Reserve with Google (Local Services Ads)</b>. Nya anslutningar eller ändringar av befintliga anslutningar stöds inte längre. För att fortsätta ta emot bokningar från Google använder du <b>Google Organic Booking</b> i stället.",
      "rwg_category": "Kategori",
      "rwg_service_type": "Tjänst",
      "connect_lsa": "Anslut till ditt annonskonto för lokala tjänster.",
      "reserve_error": "För närvarande stöds Boka med Google endast för företagsnischerna ”Home Services”, ”Real Estate”, ”Legal Services” (lokala tjänsteleverantörer) i USA.",
      "one_way": "Envägs",
      "two_way": "Tvåvägs",
      "smart": "Smart",
      "confirm_remove": "Är du säker på att du vill ta bort Google-kalendern?",
      "read_only_access": "Du har inte skrivbehörighet till den här kalendern. Välj en annan kalender.",
      "reserve_with_google_desc": "Den här kalendertjänsten kommer endast att listas som reserv hos Google efter att integrationen har genomförts.",
      "check_integration": "Kontrollera din integrationsstatus",
      "setup_external": "Konfigurera extern kalender",
      "reserve_price_decimal_error": "Decimalpris stöds inte.",
      "reserve_price_max_error": "Endast pris under 1 000 stöds.",
      "link_to_calendar_tooltip": "Välj den externa kalender som möten ska synkroniseras med. Google-kalendrar som är anslutna under Kalenderinställningar → Anslutningar finns tillgängliga att välja.",
      "one_way_sync": "Envägs",
      "default_one_way": "Standardsynkronisering (envägssynkronisering)",
      "one_way_sync_desc": "Händelser från den länkade kalendern synkroniseras som blockerade tidsluckor och gästerna skapas inte som kontakter.",
      "two_way_sync": "Tvåvägssynkronisering",
      "two_way_sync_desc": "Kontakter skapas för gäster som finns i länkade kalenderhändelser, och dessa händelser omvandlas till systemmöten.",
      "smart_sync": "Smart synkronisering",
      "smart_sync_desc": "Händelser från den länkade kalendern synkroniseras som möten för befintliga kontakter. Om ingen kontakt finns synkroniseras de som blockerade tidsluckor utan att skapa en ny kontakt.",
      "sync_option_tooltip": "Välj hur händelser från den externa kalendern ska hanteras:\n• Envägs: Blockerar tid i den här kalendern utan att skapa {contactsLabel}\n• Tvåvägs: Skapar möten och {contactsLabel} från händelser i den externa kalendern\n• Smart: Skapar möten endast för befintliga {contactsLabel} och blockerar tid för övriga.",
      "default_sync": "Standard",
      "default_sync_desc": "Synkroniserar händelser från din externa kalender till den här kalendern.",
      "advanced_sync": "Avancerat",
      "advanced_sync_desc": "Synkroniserar händelser från din externa kalender till den här kalendern och skapar kontakter och möten i systemet.",
      "assign_contact_to": "Tilldela kontakt till",
      "select_calendar": "Välj kalender",
      "sync_preferences": "Synkroniseringsinställningar",
      "sync_preferences_desc": "Hur skulle du vilja synkronisera dina länkade kalenderhändelser?",
      "recommended": "Rekommenderad",
      "execute_automation_desc": "Kör automatisering när ett möte skapas i den här kalendern.",
      "save": "Spara ändringar",
      "cancel": "Avbryt",
      "reserve_with_google_title": "Boka med Google",
      "current_connection": "Aktiv anslutning:",
      "category": "Kategori",
      "service": "Tjänstetyp",
      "price": "Uppskattat pris",
      "currency": "Valuta"
    },
    "booking_rules": {
      "booking_rules": "Bokningsregler",
      "booking_rules_description": "Styr hur och när möten kan bokas."
    },
    "payments": {
      "payments": "Betalningar",
      "payments_description": " Aktivera och hantera betalningar, regler och avgiftsmodeller."
    },
    "extras": {
      "extras": "Anpassningar",
      "extras_sub": "Ställ in widgetstil och andra inställningar.",
      "calendar_widget_style": "Kalenderwidgetens stil",
      "neo": "Ny",
      "classic": "Klassisk",
      "insert_custom_code": "Infoga anpassad kod",
      "show_seats_per_slot": "Visa platser per tidslucka",
      "allow_reschedule_meeting": "Tillåt ombokning av möte",
      "allow_cancelling_meeting": "Tillåt avbokning av möte",
      "additional_notes": "Ytterligare anteckningar",
      "cancellation_and_reschedule": "Avbokning och ombokning:",
      "allow_staff": "Tillåt val av medarbetare vid bokning",
      "code_block_tooltip": "Tredjepartsskript inuti HTML-blocket kan ge effektiva funktioner men de medför också risker för integritet, säkerhet, prestanda och sidbeteende. Därför rekommenderar vi att du granskar innehållet i det här skriptet innan du sparar det i kalendern.",
      "calendar_image": "Kalenderomslagsbild",
      "remove_image": "Ta bort bild",
      "calendar_image_info": "Den uppladdade bilden kommer att vara synlig i gruppvyn för Neo-mallen och den kommer inte att visas på den enskilda kalenderlänken.",
      "get_image_from_unsplash": "Förbättra dina bilder med",
      "unsplash": "Unsplash",
      "service_additional_preferences": "Konfigurera ytterligare inställningar",
      "service_image": "Tjänstens omslagsbild",
      "service_image_description": "Välj en bild som visas för den här tjänsten på tjänstemenyn.",
      "allow_reschedule_appointment": "Tillåt ombokning av möte",
      "allow_cancelling_appointment": "Tillåt avbokning av möte",
      "custom_code_placeholder": "Ange anpassad kod här",
      "calendar_widget_style_desc": "Välj mellan vår klassiska widget eller den eleganta Neo-widgeten.",
      "seats_per_slot": "Platser på tidslucka",
      "show_staff_selection": "Val av medarbetare",
      "seats_per_slot_desc": " Gör det möjligt för bokare att se antalet tillgängliga platser för varje tidslucka direkt i kalenderwidgeten.",
      "show_staff_selection_desc": "Gör det möjligt för bokare att välja en medarbetare direkt från kalenderwidgeten under mötesbokningen. Fungerar endast med Neo-widgeten.",
      "widget_re_order_tooltip": "Det går inte att ändra widgetordningen med den klassiska widgetstilen. Se till att datumtidsväljaren är först och att formuläret är tvåa i listan innan du väljer den klassiska stilen.",
      "show_staff_selection_desc_service": "Gör det möjligt för bokare att välja en medarbetare direkt från kalenderwidgeten under mötesbokningen.",
      "switch_to_classic_widget": "Byt till klassisk widget",
      "switch_to_classic_widget_desc": "Om du byter till <b>den klassiska widgeten</b> inaktiveras följande inställningar automatiskt, eftersom de inte kan användas samtidigt:",
      "form_first_disabled": "<b>Formulären kommer att flyttas till det andra steget</b> in Widget .",
      "appointment_preference_disabled": "<b>Inställning för nya möten (Boka alltid med {contactLabel}s tilldelade användare)</b> kommer att inaktiveras. Detta innebär att möten kan bokas med vilken tillgänglig gruppmedlem som helst, istället för att vara begränsade till {contactLabel}s tilldelade användare.",
      "multiple_location_disabled": "<b>Adresser för flera konferenser</b> kommer att vara Raderad, och endast de <b>först tillagda plattformarna</b> kommer att behållas.",
      "insert_custom_code_tooltip": "Anpassa widgetens utseende med din egen CSS-kod.",
      "classic_tooltip_disabled": "Klassisk widget stöds inte för klassbokningskalendrar.",
      "show_staff_selection_disabled_tooltip": "Val av medarbetare stöds endast i Neo-widgeten."
    },
    "roomsAndEquipments": {
      "title": "Välj rum och utrustning",
      "description": "Välj vad som ska bokas tillsammans med denna kalender från en lista över rum och utrustning.",
      "rooms": "Välj rum",
      "equipments": "Välj utrustning"
    }
  },
  "activity_log": {
    "activity_log": "Aktivitetslogg",
    "date": "Datum",
    "filter_by": "Filtrera efter",
    "calendar_update": "Uppdatering av kalender",
    "start_time_update": "Uppdatering av starttid",
    "end_time_update": "Uppdatering av sluttid",
    "title_update": "Uppdatering av titel",
    "notes_update": "Uppdatering av anteckningar",
    "appointment_status_update": "Uppdatering av mötesstatus",
    "meeting_location_update": "Uppdatering av mötesplatsen",
    "google_sync_update": "Uppdatering av Google-synkronisering",
    "outlook_sync_update": "Uppdatering av Outlook-synkronisering",
    "assigned_user_update": "Uppdatering av tilldelad användare",
    "appointment_status": "Mötesstatus",
    "assigned_user": "Tilldelad användare",
    "uploaded_to": "Uppladdad till",
    "cancelled": "Avbokade",
    "edited": "redigerade",
    "other_edits": "Övriga ändringar",
    "view_details": "Visa detaljer",
    "all": "Alla"
  },
  "appointment_list": {
    "group_all": "ALLA",
    "group_primary": "PRIMÄR",
    "group_user": "ANVÄNDARE",
    "group_team": "GRUPPER",
    "group_calendar": "KALENDRAR",
    "all_appointments": "Alla möten",
    "my_calendar": "Min kalender",
    "status_all": "Alla",
    "status_confirmed": "Bekräftad",
    "status_new": "Ny (åtgärd krävs)",
    "status_show": "Deltog",
    "status_no_show": "Uteblev",
    "status_cancelled": "Avbokade",
    "status_invalid": "Ogiltig",
    "filter_date_added_desc": "Datum tillagt (fallande)",
    "filter_start_added_desc": "Startdatum (fallande)",
    "filter_start_added_asc": "Startdatum i stigande ordning från och med idag",
    "button_new_appointment": "Nytt möte",
    "name": "Namn",
    "title": "Titel",
    "requested_time": "Efterfrågad tid",
    "date_added": "Tillagd den",
    "calendar": "Kalender",
    "appointment_owner": "Mötesägare",
    "notes": "Anteckningar",
    "status": "Status",
    "action_view_detail": "Visa detaljer",
    "action_view_consent": "Visa samtycke",
    "action_view_notes": "Visa anteckningar",
    "action_edit": "Redigera",
    "action_delete": "Radera",
    "action_reschedule": "Omboka",
    "page_previous": "Föregående",
    "page_next": "Nästa",
    "appointment_notes": "Mötesanteckningar",
    "close": "Stäng",
    "confirm_delete_header": "Ta bort möte",
    "confirm_delete_message": "Är du säker på att du vill ta bort det här mötet? Åtgärden kan inte ångras!",
    "confirm_delete_button": "Radera",
    "confirm_update_header": "Uppdatera mötesstatus",
    "confirm_update_confirmed_message": "Är du säker på att du vill markera mötet som bekräftat?",
    "confirm_update_invalid_message": "Är du säker på att du vill markera mötet som ogiltigt?",
    "confirm_update_showed_message": "Är du säker på att du vill markera mötet som deltog?",
    "confirm_update_noshow_message": "Är du säker på att du vill markera mötet som uteblev?",
    "confirm_update_cancelled_message": "Är du säker på att du vill markera mötet som avbokat?",
    "confirm_update_button": "Uppdatera",
    "empty_state_title": "Inga möten hittades",
    "empty_state_description": "Inga möten hittades.",
    "disable_menu_warning": "Du har inte behörighet att visa eller redigera mötesuppgifterna eftersom den tillhörande kontakten inte är tilldelad dig. Kontakta din administratör för hjälp.",
    "no_contact_warning": "Du kan inte komma åt kontaktinformation just nu. Det kan bero på att kontakten inte är tilldelad till dig. Kontakta administratören om du behöver hjälp.",
    "consent_label": "Samtycke",
    "ip_address": "IP",
    "youre_viewing_in": "Tittar för närvarande i",
    "appointment_delete_msg": "<b>Observera:</b> Mötet som raderas härifrån kommer inte att raderas från Calendly.",
    "rescheduled": "Ombokad"
  },
  "add_guest": {
    "guest_label": "Gäster",
    "search_placeholder": "Sök från kontakter",
    "add_new": "Lägg till ny",
    "save": "Spara",
    "close": "Stäng",
    "name": "Namn",
    "phone": "Telefon",
    "email": "E-post",
    "guest_label_count": "Antal gäster",
    "guest_count_error": "Antal gäster ska vara mellan 1 och 100"
  },
  "languages": {
    "danish": "Danish",
    "dutch": "Dutch",
    "english": "English",
    "finnish": "Finnish",
    "french": "French",
    "french_canada": "French (Canada)",
    "german": "German",
    "hungarian": "Hungarian",
    "italian": "Italian",
    "norwegian": "Norwegian",
    "polish": "Polish",
    "portuguese_brazil": "Portuguese (Brazil)",
    "portuguese_portugal": "Portuguese (Portugal)",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "turkish": "Turkish"
  },
  "service_menu_advanced": {
    "new_service_menu_details_header": "Information om tjänstemenyn",
    "select_groups_header": "Välj tjänster",
    "arrange_groups_header": "Ordna dina tjänster",
    "new_service_menu": "Ny tjänstemeny",
    "service_menu_sub_title": "Skapa en personlig tjänstemeny för dina kunder med bara några klick",
    "quick_tip": "Du kan lägga till grupper till tjänstemenyn",
    "service_menu_name": "Namn på tjänstemenyn",
    "service_menu_description": "Beskrivning",
    "service_menu_slug": "Tjänstens URL",
    "select_groups_calendars": "Välj grupper och kalendrar",
    "select_groups_calendars_desc": "Lägg till tjänster i tjänstemenyn",
    "select_all": "Välj alla",
    "arrange_groups": "Ordna tjänsternas följd",
    "arrange_groups_desc": "Bestäm ordningsföljden för tjänsterna på tjänstemenyn",
    "arrange_services_quicktip": "Om du vill ändra ordning på kalendrar inom en grupp går du till Grupper > Alternativ > Ordna om kalendrar.",
    "enable_add_guest_desc": "Tillåter kunder att inkludera ytterligare gäster när de gör en bokning.",
    "enable_multiple_service_desc": "Tillåter kunder att boka flera tjänster i ett enda möte.",
    "enable_staff_selection_desc": "Tillåter kunder att välja föredragna medarbetare när de gör en bokning.",
    "enable_add_guest": "Aktivera lägg till gäster",
    "enable_multiple_service": "Aktivera Val av flera tjänster",
    "enable_staff_selection": "Aktivera Val av medarbetare",
    "additional_options": "Ytterligare alternativ",
    "code_block_tooltip": "Tredjepartsskript inuti HTML-blocket kan ge effektiva funktioner men de medför också risker för integritet, säkerhet, prestanda och sidbeteende. Därför rekommenderar vi att du granskar innehållet i det här skriptet innan du sparar det i tjänstemenyn.",
    "custom_code_placeholder": "Ange anpassad kod här",
    "insert_custom_code": "Infoga anpassad kod",
    "no_service": "Ingen tjänst hittades",
    "no_service_desc": " Inga tjänster hittades. Skapa tjänster och lägg till dem i grupper för att skapa en tjänstemeny.",
    "learn_more": "Läs mer",
    "no_service_selected": "Ingen tjänst har valts",
    "create_service_calendars": "Skapa tjänstekalendrar",
    "alert_description": " För att kunna skapa tjänstemenyer måste du skapa tjänstekalendrar och lägga till dem i grupper.",
    "dont_show_again": "Visa inte det här igen",
    "service_name_required": "Namn på tjänstemenyn krävs",
    "slug_already_taken": "Denna slug är redan upptagen",
    "slug_required": "Slug krävs",
    "please_enter_name": "Ange ett namn",
    "service_name_placeholder": "Huvudmeny",
    "service_slug_placeholder": "huvudmeny",
    "form_label": "Formulär",
    "consent_label": "Kryssruta för samtycke",
    "consent_input_placeholder": "Lägg till samtyckestext",
    "consent_tooltip": "Aktivera det här alternativet för att tillåta inhämtande av samtycke från {contactsLabel} när de anger sitt telefonnummer under mötesbokningsprocessen.",
    "back_message": "Gå tillbaka till listan",
    "saving_changes": "Bara en minut — Sparar den senaste Dynamisk...",
    "payment_provider_warning": "Viktig information! Servicemenyer stöder för närvarande bara betalning via Stripe och Authorize.net. Eftersom du har en annan standardleverantör kommer inkasseringen för markerade kalendrar med aktiverad betalning att hoppas över.",
    "aria": {
      "consent_form_toggle": "Växlingsknapp för samtyckesformulär",
      "enable_add_guest_toggle": "Växlingsknapp för aktivering att gästtillägg",
      "enable_multiple_services_toggle": "Växlingsknapp för aktivering av flera tjänster",
      "enable_staff_selection_toggle": "Växlingsknapp för aktivering av val av personal"
    }
  },
  "widget_configuration": {
    "customise_calendar_widget": "Anpassa kalenderwidgeten",
    "works_with_neo_widget": "Fungerar endast med Neo-widgeten",
    "customise_widget_desc": "Anpassa widgetens utseende: primär färg, bakgrundsfärg och knapptext.",
    "learn_more": "Läs mer",
    "primary_settings": "Primära inställningar",
    "primary_settings_desc": "Konfigurera primärfärg, bakgrundsfärg och andra widgetinställningar för att skräddarsy din kalenderwidget.",
    "primary_color": "Primärfärg",
    "primary_color_desc": "Ställ in färgen på knappar, datum, tidsluckor och åtgärder.",
    "background_color": "Bakgrundsfärg",
    "background_color_desc": "Ställ in bakgrundsfärgen som fungerar som bakgrund för både datum- och tidsväljaren och formuläret.",
    "button_text": "Knapptext",
    "button_text_desc": "Anpassa texten som visas på knappen när man bokar ett möte.",
    "calendar_title": "Kalendertitel",
    "calendar_title_desc": "Namnet på din kalender",
    "calendar_description": "Kalenderbeskrivning",
    "calendar_description_desc": "Den angivna beskrivningen.",
    "calendar_details": "Kalenderinformation",
    "calendar_details_desc": "Innehåller information som varaktighet, datum och tid, återkommande information och tidszon.",
    "reset_to_default": "Återställ till standard",
    "preview_widget": "Förhandsgranska widget",
    "calendar_title_tooltip": "Ange om kalendernamnet och gruppnamnet (om tillämpligt) ska visas i bokningswidgeten.",
    "calendar_description_tooltip": "Ange om kalenderbeskrivningen ska visas i bokningswidgeten.",
    "calendar_details_tooltip": "Samling Om Nyckelmötena Detaljer som Konferenser Varaktighet, Markerad Datum & Datum och upprepningsinfo (om tillämpligt) ska synas i Bokningswidgeten.",
    "insert_custom_code_tooltip": "Anpassa Widget styling Via din egen CSS kod.",
    "staff_selection_tooltip": "Aktivera Bokare för att välja en medarbetare Medlemmar direkt Från Widget under Möte-bokningen. Fungerar endast med Neo Widget."
  },
  "eventNotification": {
    "customFields": "Anpassade fält",
    "customValues": "Anpassade värden",
    "templateVariableIssueDefaultPartBefore": "Det finns problem med er ",
    "templateVariableIssueDefaultPartHighlight": "anpassade värden",
    "templateVariableIssueDefaultPartAfter": "; granska och korrigera dem innan du sparar.",
    "templateVariableInvalidListOverflow": "... och {count} till",
    "templateVariableIssueSingle": "Det finns ett problem med det här anpassade värdet: {value}; korrigera det innan du sparar.",
    "templateVariableIssueEmpty": "Ett eller flera anpassade värden är tomma ({emptyPair}); lägg till ett giltigt fält inom parenteserna.",
    "templateVariableIssueMarkup": "Vissa anpassade värden inkluderar HTML eller formatering, vilket inte stöds; ta bort det innan du sparar.",
    "templateVariableSaveFailed": "Det gick inte att spara {receiverLabel}-aviseringen. Åtgärda felen i de anpassade värdena innan du sparar.",
    "templateVariableSaveFailedGeneric": "Det gick inte att spara aviseringen. Åtgärda felen i de anpassade värdena innan du sparar.",
    "guest": "Gäst",
    "assignedUser": "Tilldelad användare",
    "additionalEmails": "Ytterligare e-postmeddelanden",
    "list": {
      "booked": {
        "title": "Möte bokat (status: obekräftat)",
        "modalTitle": "möte bokat (status: obekräftat)",
        "note": "Den här Aviseringen skickas När a Ny Möte är skapad med Status Ej bekräftad .",
        "subTitle": "Meddelar när ett möte bokas med statusen obekräftat."
      },
      "confirmation": {
        "title": "Möte bokat (status: bekräftat)",
        "modalTitle": "möte bokat (status: bekräftat)",
        "note": "Denna Avisering skickas När an Möte är skapad med Eller Uppdaterad till Bekräftad Status.",
        "subTitle": "Meddelar när ett möte har bekräftats."
      },
      "cancellation": {
        "title": "Avbokning",
        "modalTitle": "avbokning",
        "note": "Denna Avisering skickas När an Möte är inställd, markerad som Uteblev, Eller markerad som Ogiltig.",
        "subTitle": "Meddelar när ett möte avbokas."
      },
      "reschedule": {
        "title": "Omboka",
        "modalTitle": "omboka",
        "note": "Denna Avisering skickas När an Möte är ombokad. Den kommer endast att utlösas om Möte in Status Ej bekräftad Eller Bekräftad .",
        "subTitle": "Meddelar när ett möte ombokas"
      },
      "reminder": {
        "title": "Påminnelse",
        "modalTitle": "påminnelse",
        "note": "Denna Avisering skickas som en Påminnelse Före the Möte. Den kommer endast att utlösas om Möte in Status Ej bekräftad Eller Bekräftad .",
        "subTitle": "Skickar en påminnelse före mötet."
      },
      "followup": {
        "title": "uppföljning",
        "modalTitle": "uppföljning",
        "note": "Denna Avisering skickas Efter the Möte som en uppföljning. Den kommer endast att utlösas Om Möte är in Ej bekräftad, Bekräftad, Eller Deltog Status.",
        "subTitle": "Skickar ett uppföljningsmeddelande efter att mötet är klart."
      }
    },
    "saveToastMsg": "Inställningar har sparats!",
    "saveToastMsgDesc": "Dina ändringar har sparats",
    "enableSuccess": "Aviseringar har aktiverats!",
    "disableSuccess": "Aviseringar har inaktiverats!",
    "tooltip": "Denna Avisering har inaktiverats. Aktivera den för att skapa valfri Dynamisk.",
    "enabled": "Aktiverad",
    "disabled": "Inaktiverad",
    "statusLabel": "Statusetiketter",
    "email": {
      "channelName": "E-post",
      "noneTemplate": "Ingen",
      "notificationLabel": "Vem ska få den här aviseringen?",
      "sendButtonLabel": "Skicka testmejl",
      "testEmailLabel": "Testmejl",
      "testEmailPlaceholder": "Ange mottagarens e-postadress för testet",
      "body": "Mejlets brödtext",
      "bodyPlaceholder": "Skriv ditt meddelande här",
      "subject": "Ämne",
      "subjectPlaceholder": "Ange e-postmeddelandets ämne",
      "templateLabel": "E-postmall",
      "templatePlaceholder": "Välj en e-postmall eller börja från grunden",
      "fromNamePlaceholder": "Ange namn",
      "fromNameLabel": "Från namn",
      "fromAddressLabel": "Från adress",
      "alertEmailAddress": "Ange e-postadresser (avgränsade med kommatecken)",
      "addMore": "Lägg till mer",
      "afterAppointmentEnds": "efter att mötet är slut",
      "beforeAppointmentStarts": "innan mötet börjar",
      "durationLabel": "När vill du att aviseringen ska skickas?",
      "disableEmailNotification": "Inaktivera e-postaviseringar",
      "enableEmailNotification": "Aktivera e-postaviseringar",
      "enableSuccess": "E-postavisering aktiverad!",
      "enableSuccessDesc": "Du kommer nu att börja få den här aviseringen",
      "disableSuccess": "E-postavisering inaktiverad!",
      "disableSuccessDesc": "Du kommer inte längre att få den här aviseringen",
      "reset_to_default": "Återställ till Standard",
      "testEmailSuccessTitle": "Testmejl har skickats!",
      "testEmailSuccessDesc": "Testmejl har skickats till {email}",
      "testEmailErrorTitle": "Det gick inte att skicka testmejl",
      "testEmailErrorDesc": "Det uppstod ett fel när testmejlet skickades. Försök igen.",
      "create_new_email_template": "Skapa ny e-postmall",
      "templateVariableFieldSubject": "Ämnesrad",
      "templateVariableFieldFromName": "Från namn",
      "templateVariableFieldFromAddress": "Från adress",
      "templateVariableFieldEmailBody": "Mejlets brödtext"
    },
    "inApp": {
      "channelName": "in-app",
      "title": "Aviseringsinställningar",
      "enableInAppNotification": "Aktivera aviseringar i appen",
      "disableInAppNotification": "Inaktivera aviseringar i appen",
      "selectedUser": {
        "label": "Skicka till",
        "helperText": "Den interna aviseringen skickas via webben och mobilappar.",
        "placeholder": "Välj användare"
      },
      "enableSuccess": "Aviseringar i appen har aktiverats!",
      "enableSuccessDesc": "Du kommer nu att börja få den här aviseringen.",
      "disableSuccess": "Aviseringar i appen har inaktiverats!",
      "disableSuccessDesc": "Du kommer inte längre att få aviseringen."
    },
    "sms": {
      "channelName": "SMS",
      "noneTemplate": "Inga",
      "notificationLabel": "Vem ska få den här aviseringen?",
      "sendButtonLabel": "Skicka test-SMS",
      "testSMSLabel": "Test-SMS (ange telefonnummer med landskod)",
      "testSMSPlaceholder": "+12345678901",
      "body": "SMS-meddelande",
      "bodyPlaceholder": "Skriv ditt SMS-meddelande här",
      "durationLabel": "När vill du att aviseringen ska skickas?",
      "disableSMSNotification": "Inaktivera SMS-aviseringar",
      "enableSMSNotification": "Aktivera SMS-aviseringar",
      "enableSuccess": "SMS-avisering har aktiverats!",
      "enableSuccessDesc": "Du kommer nu att börja få aviseringen.",
      "disableSuccess": "SMS-avisering har inaktiverats!",
      "disableSuccessDesc": "Du kommer inte längre att få aviseringen.",
      "alertPhoneNumbers": "Ange telefonnummer (med landskod, avgränsade med kommatecken)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Lägg till fler",
      "afterAppointmentEnds": "efter att mötet är slut",
      "beforeAppointmentStarts": "innan mötet börjar",
      "templateLabel": "SMS-mall",
      "templatePlaceholder": "Välj SMS-mall ...",
      "reset_to_default": "Återställ till standard",
      "testSmsSuccessTitle": "Test-SMS har skickats!",
      "testSmsSuccessDesc": "Test-SMS har skickats till {phone}.",
      "testSmsErrorTitle": "Det gick inte att skicka test-SMS",
      "testSmsErrorDesc": "Det uppstod ett fel när test-SMS:et skickades. Försök igen.",
      "templateVariableFieldSmsBody": "Meddelandetext"
    },
    "whatsapp": {
      "channelName": "WhatsApp",
      "notificationLabel": "Vem ska få den här aviseringen?",
      "sendButtonLabel": "Skicka testavisering på WhatsApp",
      "testWhatsAppLabel": "Testavisering för WhatsApp (ange telefonnummer med landskod).",
      "testWhatsAppPlaceholder": "+12345678901",
      "durationLabel": "När vill du att aviseringen ska skickas?",
      "alertPhoneNumbers": "Ange telefonnummer (med landskod, avgränsade med kommatecken)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Lägg till fler",
      "afterAppointmentEnds": "efter att mötet är slut",
      "beforeAppointmentStarts": "innan mötet börjar",
      "templateLabel": "WhatsApp-mall",
      "templatePlaceholder": "Välj WhatsApp-mall …",
      "noPreview": "Ingen mall har valts",
      "templateRequired": "Mall krävs",
      "testWhatsAppSuccessTitle": "Testavisering för WhatsApp har skickats!",
      "testWhatsAppSuccessDesc": "WhatsApp-testnotisen har skickats till {phone}.",
      "testWhatsAppErrorTitle": "Det gick inte att skicka WhatsApp-aviseringen.",
      "testWhatsAppErrorDesc": "Det uppstod ett fel när WhatsApp-aviseringen skickades. Försök igen.",
      "setupTitle": "Kontakta din kund via den app där de oftast skickar meddelanden.",
      "setupDescription": "Kom närmare dina kunder genom att erbjuda omedelbar support, skicka uppdateringar vid rätt tidpunkt och skapa engagerande interaktioner.",
      "connectWhatsApp": "Anslut WhatsApp",
      "checkingStatus": "Kontrollerar status för WhatsApp-konto …",
      "checkingTemplateStatus": "Kontrollerar status för WhatsApp-mallen…",
      "statusCheckError": "Det gick inte att kontrollera statusen för WhatsApp-kontot.",
      "templateStatusCheckError": "Det gick inte att kontrollera statusen för WhatsApp-mallen.",
      "setupTemplateTitle": "Slutför konfigurationen av din WhatsApp-mall.",
      "setupTemplateDescription": "Du måste Konfigurera WhatsApp-mallar Före du kan Ladda upp aviseringar. Klicka nedan för att slutföra konfigurationen.",
      "loadTemplatesError": "Det gick inte att läsa in WhatsApp-mallar.",
      "templatesRefreshed": "Mallarna har uppdaterats framgångsrikt",
      "templatesRefreshError": "Det gick inte att uppdatera mallar.",
      "templatesResolveError": "Det uppstod ett fel när WhatsApp-standardmallarna skulle åtgärdas.",
      "locationNotFound": "Det gick inte att hitta plats-ID.",
      "settingsRedirectError": "Det gick inte att omdirigera till WhatsApp-inställningarna.",
      "updateNotificationError": "Det gick inte att uppdatera WhatsApp-aviseringen.",
      "notificationsEnabled": "WhatsApp-aviseringar är aktiverade!",
      "notificationsDisabled": "WhatsApp-aviseringar har inaktiverats!",
      "updateError": "Fel vid uppdatering av aviseringar.",
      "createNewTemplate": "Skapa en ny WhatsApp-mall",
      "phoneValidation": {
        "countryCodeRequired": "Telefonnumret måste börja med landskod (t.ex. +1, +91, +44)",
        "digitsOnly": "Telefonnumret får endast innehålla siffror efter landskoden.",
        "tooShort": "Telefonnumret är för kort.",
        "tooLong": "Telefonnumret är för långt.",
        "invalid": "Ogiltigt telefonnummer."
      },
      "errors": {
        "templateNotFound": "Mall-ID hittades inte bland de laddade alternativen, rensar",
        "templateNoLongerValid": "Sparad mall är inte längre giltig, rensar.",
        "invalidTemplateSelection": "Försökte välja ogiltig WhatsApp-mall.",
        "fetchingTemplates": "Fel vid hämtning av WhatsApp-mallar.",
        "mountingCreator": "Fel vid montering av WhatsApp-mallbyggaren.",
        "fetchingAfterCreation": "Fel vid hämtning av WhatsApp-mallar efter skapandet.",
        "updateStatus": "Fel vid uppdatering av WhatsApp-status."
      },
      "receiverLabels": {
        "assignedUser": "Tilldelad användare",
        "phoneNumbers": "Ytterligare telefonnummer"
      }
    }
  },
  "smsTemplate": {
    "create_new_template": "Skapa ny SMS-mall.",
    "create_new_template_desc": "Skapa en återanvändbar SMS-mall för dina aviseringar.",
    "template_name": "Mallnamn",
    "template_name_placeholder": "Ange mallens namn",
    "message": "Meddelande",
    "message_placeholder": "Skriv ditt SMS-meddelande här.",
    "create_template": "Skapa mall",
    "name_required": "Namn på mallen krävs",
    "text_required": "Meddelandetext krävs",
    "fetch_new_templates": "Uppdatera mallar",
    "characters": "tecken",
    "words": "ord",
    "segments": "segment"
  },
  "whatsappTemplate": {
    "create_new_template": "Skapa en ny WhatsApp-mall",
    "create_new_template_desc": "Skapa en återanvändbar WhatsApp-mall för dina aviseringar.",
    "template_name": "Mallnamn",
    "template_name_placeholder": "Ange mallens namn",
    "message": "Meddelande",
    "message_placeholder": "Skriv ditt WhatsApp-meddelande här.",
    "create_template": "Skapa mall",
    "name_required": "Namn på mallen krävs",
    "text_required": "Meddelandetext krävs",
    "fetch_new_templates": "Uppdatera mallar"
  },
  "archivedServices": {
    "servicesBanner": "En ny, uppgraderad version av tjänster är här – mer kraftfull, flexibel och intuitiv. Dina tjänstekalendrar har redan migrerats. Utforska dem nu på fliken Tjänster.",
    "archivedServiceCalendars": "Tjänstekalendrar (v1)",
    "check_new_services": "Kontrollera nya tjänster"
  },
  "tour": {
    "hidden_test_label": "Test",
    "calendar": {
      "edit_calendar": "Redigera kalender",
      "share_calendar": "Dela kalender",
      "troubleshoot_calendar": "Felsök kalender",
      "more_options": "Fler alternativ",
      "edit_calendar_desc": "Hantera varje kalenderinställningar – Fixerad Tillgänglighet, Konfigurera Påminnelse, Ändra Möte limits med mera.",
      "share_calendar_desc": "Kopiera och Dela ditt Schemaläggningslänk så kan Bokare enkelt schemalägga med Du.",
      "troubleshoot_calendar_desc": "Ta reda på varför en plats inte visas och se möjliga orsaker i felsökningsvyn.",
      "more_options_desc": "Åtkomst ytterligare Inställningar och aktiviteter till Hantera din kalender.",
      "read_permissions": {
        "share_description": "Ge andra åtkomst genom att dela kalenderlänken eller justera behörigheter.",
        "troubleshoot_description": "Identifiera och lös problem som synkroniseringsfel eller saknade händelser för smidig funktionalitet."
      },
      "next": "Nästa",
      "start_over": "Börja om",
      "all_set": "Klart!",
      "previous": "Föregående"
    }
  },
  "emailTemplate": {
    "select_editing_experience": "Välj din redigeringsupplevelse",
    "select_editing_experience_desc": "Bygg med hjälp av vår visuella dra-och-släpp-designredigerare eller den kraftfulla kodredigeraren.",
    "design_editor": "Designredigerare",
    "design_editor_desc": "Visuell redigering med dra och släpp-funktion.",
    "code_editor": "Kodredigerare",
    "code_editor_desc": "HTML-redigering med många funktioner.",
    "text_editor": "Textredigerare utan formatering",
    "text_editor_desc": "Enkel, ren textredigering utan krusiduller.",
    "email_text_block": "E-post kan även skapas Via Brödtext Block. ",
    "select": "Välj",
    "new_template": "Ny mall",
    "email_block": "E-post kan också skapas med hjälp av textblock.",
    "fetch_new_templates": "Hämta nya mallar"
  },
  "quick_tips": {
    "meeting_details": {
      "clear_name_and_description": "Använd ett tydligt mötesnamn och en tydlig beskrivning så att den som bokar vet exakt vad som bokas.",
      "groups_share_link": "Med grupper kan du dela en schemaläggningslänk för flera kalendrar, så att kunder kan välja och boka bland tillgängliga alternativ."
    },
    "staff_location": {
      "custom_location": "Välj Anpassad som mötesplats för att ange valfri adress eller länk.",
      "ask_booker_location": "När Fråga bokaren har valts ombeds den som bokar att ange mötesplats vid bokning.",
      "round_robin_priority": "Prioritetsinställningar påverkar hur möten fördelas när flera medarbetare är tillgängliga.",
      "connect_video_integrations": "Anslut videokonferensintegreringar under Kalenderinställningar → Anslutningar innan du väljer dem som mötesplats."
    },
    "availability": {
      "staff_availability_required": "Möten kan endast bokas när minst en vald medarbetare är tillgänglig.",
      "use_precreated_schedule": "Du kan använda ett färdigt tillgänglighetsschema från Kalenderinställningar → Tillgänglighet eller skapa ett anpassat schema endast för den här kalendern.",
      "timezone_in_schedule": "Tidszonen för möten anges i det valda tillgänglighetsschemat.",
      "event_24_hours": "För att göra en kalender tillgänglig 24 timmar om dygnet, ställ in tidsintervallet från 00:00 till 00:00."
    },
    "booking_rules": {
      "apply_to_all_meetings": "Bokningsregler gäller för alla möten i den här kalendern, oavsett medarbetarnas tillgänglighet.",
      "minimum_scheduling_notice": "Öka den minsta bokningsmarginalen för att förhindra bokningar i sista minuten.",
      "maximum_bookings_per_slot": "Använd maximalt antal bokningar per tidslucka för att styra hur många möten som kan ske samtidigt."
    },
    "forms": {
      "custom_contact_fields": "Du kan inkludera anpassade kontaktfält i både formulärmeddelanden och formulär-URL:er.",
      "create_custom_form": "För att samla in mer information skapar du ett anpassat formulär via Webbplatser → Formulär → Byggare och använder det med den här kalendern."
    },
    "payments": {
      "collected_during_booking": "Betalningar tas ut vid bokning och måste slutföras innan mötet bekräftas.",
      "payment_description": "Använd betalningsbeskrivningen för att tydligt förklara vad avgiften avser."
    },
    "notifications": {
      "review_policies": "Se över avboknings- och ombokningspolicyer för att undvika ändringar i sista minuten.",
      "use_workflows": "För avancerad automatisering använder du arbetsflöden eller utlösare för bokade möten."
    },
    "customizations": {
      "preview_widget": "Förhandsgranska widgeten för att säkerställa att den matchar ditt varumärke och ditt bokningsflöde.",
      "update_widget_language": "Språkinställningar för widgeten kan ändras via Inställningar → Kalendrar → Inställningar."
    },
    "connections": {
      "google_organic_booking": "Genom att konfigurera Google Organic Booking kan den här kalendern ta emot bokningar direkt från Google Sök.",
      "external_sync_event": "Endast den kalender som valts under Extern synkronisering används för att hämta och skicka händelser för den här kalendern."
    },
    "equipments": {
      "room_definition": "Ett ”rum” kan representera vilken plats som helst där tjänster tillhandahålls. Detta kan vara fysiska rum och/eller dedikerade stationer. T.ex.: Pedikyrstation.",
      "equipment_definition": "Tänk på ”utrustning” som alla verktyg eller enheter som företag använder för att utföra möten. Detta kan inkludera maskiner, apparater eller till och med stolar."
    }
  },
  "aria_labels": {
    "sticky_contacts": "Fästa kontakter",
    "consent_form": "Samtyckesformulär",
    "enable_guests": "Aktivera gäster",
    "auto_confirm": "Automatisk bekräftelse",
    "should_accept_payment": "Bör acceptera betalning",
    "collect_deposit": "Ta ut deposition",
    "enable_charge_guests": "Aktivera debitering av gäster",
    "enable_coupon": "Aktivera kupong",
    "payment_live": "Betalning live",
    "add_availability_hour": "Lägg till tillgängliga timmar",
    "remove_availability_hour": "Ta bort tillgängliga timmar",
    "copy_availability_hour": "Kopiera tillgänglighet",
    "close_modal": "Stäng modal",
    "add_custom_slot": "Lägg till anpassad tidslucka",
    "remove_custom_slot": "Ta bort anpassad tidslucka",
    "edit_custom_slot": "Redigera anpassad tidslucka",
    "update_frequency": "Uppdateringsfrekvens",
    "show_calendar_title": "Visa kalendertitel",
    "show_calendar_description": "Visa kalenderbeskrivning.",
    "show_calendar_details": "Visa kalenderinformation",
    "allow_reschedule": "Tillåt ombokning",
    "allow_cancellation": "Tillåt avbokning",
    "category_actions": "Kategoriåtgärder",
    "show_seats_per_slot": "Visa platser per tidslucka",
    "add_more": "Lägg till fler",
    "same_user_assignment_toggle": "Växlare för tilldelning till samma användare"
  },
  "placeholders": {
    "pixel_id": "Pixel-ID",
    "select_one": "Välj en",
    "meeting_location": "Mötesplats",
    "schedule_meeting": "Schemalägg möte",
    "notes": "Anteckningar",
    "select_users": "Välj användare",
    "please_select": "Välj"
  },
  "alt_text": {
    "payment_provider": "Betalningsleverantör",
    "no_calendars": "Inga kalendrar",
    "date_specific_hours": "datumspecifika timmar",
    "custom_widget_image": "Anpassad widgetbild",
    "service_calendar": "Tjänstekalender",
    "event_calendar": "Evenemangskalender",
    "round_robin_booking": "Round Robin-bokning",
    "class_booking": "Klassbokning",
    "collective_booking": "Kollektiv bokning",
    "calendar_cover_image": "Kalenderomslagsbild",
    "email_notification_switch": "Växlare för e-postavisering",
    "email_template_icon": "Ikon för e-postmall",
    "in_app_notification_switch": "Växlare för avisering i appen",
    "sms_notification_switch": "Växlare för SMS-avisering",
    "whatsapp_notification_switch": "Växlare för WhatsApp-avisering",
    "no_service_found": "Ingen tjänst hittades",
    "no_group_found": "Ingen grupp hittades",
    "sync_icon": "Synkroniseringsikon",
    "sync_type": "Synkroniseringstyp",
    "test1": "test1",
    "test2": "test2"
  },
  "tooltips": {
    "text_color": "Textfärg",
    "background_color": "Bakgrundsfärg",
    "strikethrough": "Genomstruken",
    "superscript": "Superscript",
    "subscript": "Subskript",
    "inline_code_block": "Inline-kodblock",
    "code_block": "Kodblock",
    "block_quote": "Blockcitat",
    "more": "Mer",
    "upload": "Ladda upp",
    "image_upload_tooltip": "PNG, JPEG, JPG eller GIF (max. mått 180x180px | max. storlek 2,5 MB)",
    "custom_values": "Anpassade värden",
    "text_wrap": "Textradbrytning",
    "trigger_links": "Utlösarlänkar",
    "text_align": "Textjustering"
  },
  "labels": {
    "reset_style": "Återställ stil",
    "reset_document_style": "Återställ dokumentstil",
    "source_code": "Källkod",
    "success": "Framgång",
    "edit": "Redigera",
    "submit": "Spara",
    "cancel": "Avbryt",
    "payment": "Betalning",
    "here_is_the_link": "Här är länken:",
    "here_is_the_embed_code": "Här är den inbäddade koden:",
    "service_calendar": "Tjänstekalender",
    "collective_booking": "Kollektiv bokning",
    "class_booking": "Klassbokning",
    "round_robin_booking": "Round robin-bokning",
    "event_calendar": "Evenemangskalender",
    "personal_booking": "Personlig bokning",
    "service_booking": "Tjänstebokning",
    "calendar_id": "Kalender-ID"
  },
  "validation_messages": {
    "calendar_group_name_required": "Kalendergruppens namn krävs.",
    "calendar_group_description_required": "Beskrivning av kalendergruppen krävs.",
    "slug_required": "Slug krävs.",
    "slug_not_valid": "Denna slug är inte giltig.",
    "slug_already_taken": "Denna slug är redan upptagen.",
    "error_validating_slug": "Fel vid validering av slug.",
    "please_enter_name": "Ange ett namn.",
    "room_name_required": "Rumsnamn krävs",
    "equipment_name_required": "Utrustningens namn krävs.",
    "subject_required": "Ämne krävs.",
    "this_is_required": "Detta krävs.",
    "calendar_group_slug_required": "Kalendergruppens slug krävs.",
    "capacity_mandatory": "Kapacitet krävs.",
    "capacity_cannot_be_zero": "Kapacitet kan inte vara noll.",
    "capacity_should_be_a_number": "Kapaciteten måste vara en siffra.",
    "capacity_cannot_be_negative": "Kapacitet kan inte vara negativ.",
    "capacity_should_be_a_whole_number": "Kapaciteten måste vara ett heltal.",
    "quantity_mandatory": "Antal krävs",
    "quantity_cannot_be_zero": "Antal får inte vara noll.",
    "quantity_should_be_a_number": "Antal måste vara en siffra.",
    "quantity_cannot_be_negative": "Antal får inte vara negativt.",
    "quantity_should_be_a_whole_number": "Antal måste vara ett heltal.",
    "quantity_cannot_be_less_than_out_of_service_equipments": "Antal får inte vara mindre än mängden utrustning som tagits ur bruk.",
    "out_of_service_value_should_be_a_number": "Värdet för antal ur bruk ska vara en siffra.",
    "out_of_service_cannot_be_negative": "Antal ur bruk får inte vara negativt",
    "out_of_service_equipments_qty": "Utrustning som tagits ur bruk kan inte vara fler än den faktiska mängden utrustning.",
    "out_of_service_whole_number": "Antal ur bruk måste vara ett heltal.",
    "slot_duration_required": "Varaktighet för tidslucka krävs.",
    "slot_duration_integer": "Tidsluckans varaktighet måste vara ett heltal.",
    "meeting_duration_validation": "Mötets varaktighet måste vara mellan 1 min och 12 timmar",
    "seats_class_required": "Antal platser per klass krävs.",
    "seats_class_integer": "Antal platser per klass ska vara ett heltal.",
    "seats_class_validation": "Detta får inte vara större än 9999 eller mindre än 0.",
    "meeting_location_required": "Mötesplats krävs.",
    "meeting_location_empty": "Ange ett värde för alla platstyper.",
    "meeting_location_duplicate": "Duplicerat värde för samma platstyp är inte tillåtet.",
    "meeting_location_booker_multiple": "Fråga bokaren är inte tillåtet för flera teammedlemmar."
  },
  "custom_values": {
    "assigned_user": "Tilldelad användare",
    "full_name": "Fullständigt namn",
    "first_name": "Förnamn",
    "last_name": "Efternamn",
    "email": "E-post",
    "phone": "Telefon",
    "twilio_phone": "Twilio-telefon",
    "account": "Konto",
    "name": "Namn",
    "full_address": "Fullständig adress",
    "city": "Stad",
    "state": "Delstat",
    "country": "Land",
    "postal_code": "Postnummer",
    "contact": "Kontakt",
    "address1": "Adress 1",
    "timezone": "Tidszon",
    "user": "Användare",
    "appointment": "Möte",
    "start_date_time": "Startdatum och tid",
    "start_date": "Startdatum",
    "start_time": "Starttid",
    "end_date_time": "Slutdatum och tid",
    "end_date": "Slutdatum",
    "end_time": "Sluttid",
    "meeting_location": "Mötesplats"
  },
  "meeting_location_types": {
    "zoom": "Zoom",
    "google_meet": "Google Meet",
    "phone": "Telefon",
    "full_address": "Fullständig adress",
    "microsoft_teams": "Microsoft Teams",
    "custom": "Anpassad"
  },
  "duration_units": {
    "minutes": "Minuter",
    "hours": "Timmar"
  },
  "widget_styles": {
    "classic": "Klassisk",
    "neo": "Neo"
  },
  "feature_labels": {
    "service_menu": "Tjänstemeny",
    "rooms": "Rum",
    "equipments": "Utrustning"
  },
  "lsa": {
    "categories": {
      "accountant": "Redovisning",
      "acupuncturist": "Akupunktur",
      "air_duct_cleaner": "Rengöring av ventilationskanaler",
      "alcohol_treatment": "Tjänster för behandling av alkoholism",
      "animal_shelter": "Djurräddningstjänster",
      "appliance_repair": "Reparation av hushållsapparater",
      "architect": "Arkitektur",
      "assisted_living": "Tjänster för assisterat boende",
      "babysitter": "Barnpassning",
      "bankruptcy_lawyer": "Konkursrätt",
      "beauty_school": "Skönhetsskola",
      "business_lawyer": "Affärsjuridik",
      "car_repair": "Biltjänster",
      "carpenter": "Snickeri",
      "carpet_cleaning": "Rengöring av mattor",
      "child_care": "Tjänster för barnomsorg",
      "chiropractor": "Kiropraktiska tjänster",
      "cleaning_service": "Hemstädning",
      "contract_lawyer": "Kontraktsrätt",
      "countertop_pro": "Tjänster över disk",
      "criminal_lawyer": "Straffrätt",
      "dance_instructor": "Dansinstruktion",
      "disability_lawyer": "Handikapprätt",
      "driving_instructor": "Körinstruktion",
      "dui_lawyer": "Rattfyllerilagen",
      "electrician": "Elektrisk",
      "energy_efficiency_pro": "Energieffektivitetstjänster",
      "estate_lawyer": "Fastighetsrätt",
      "event_planner": "Evenemangsplanering",
      "family_lawyer": "Familjerätt",
      "fencing_pro": "Inhägnad",
      "financial_planner": "Finansiell planering",
      "first_aid_trainer": "Första hjälpen-kurs",
      "flooring_pro": "Golvläggning",
      "foundation_pro": "Grunder",
      "funeral_home": "Begravningstjänster",
      "garage_door_pro": "Garageport",
      "general_contractor": "Hemrenovering",
      "handyman": "Hantverkare",
      "home_inspector": "Husbesiktning",
      "home_security": "Säkerhetstjänster för hemmet",
      "home_theater": "Hemmabiotjänster",
      "hvac": "HVAC",
      "immigration_lawyer": "Invandringsrätt",
      "interior_designer": "Inredningsdesign",
      "ip_lawyer": "Immaterialrätt",
      "junk_removal": "Borttagning av skräp",
      "labor_lawyer": "Arbetsrätt",
      "landscaper": "Landskapsarkitektur",
      "language_instructor": "Språkinstruktion",
      "lawn_care": "Gräsmatteskötsel",
      "litigation_lawyer": "Tvisterätt",
      "locksmith": "Låssmed",
      "malpractice_lawyer": "Malpraxisrätt",
      "massage_center": "Massagetjänster",
      "massage_school": "Massageskola",
      "mover": "Flyttar",
      "nursing_home": "Tjänster för äldreboende",
      "painter": "Målning",
      "personal_injury_lawyer": "Personskaderätt",
      "personal_trainer": "Personlig träning",
      "pest_control": "Skadedjurskontroll",
      "pet_adoption": "Adoptionstjänster för husdjur",
      "pet_boarding": "Pensionat för husdjur",
      "pet_grooming": "Husdjursvård",
      "pet_trainer": "Husdjursträning",
      "photographer": "Fotografi",
      "plumber": "Rörmokeri",
      "pool_cleaner": "Poolrengöring",
      "pool_contractor": "Poolentreprenad",
      "preschool": "Förskola",
      "psychologist": "Psykologtjänster",
      "real_estate_agent": "Fastigheter",
      "real_estate_lawyer": "Fastighetsrätt",
      "rehab": "Rehabiliteringstjänster",
      "roofer": "Takläggning",
      "sewage_pro": "Avloppstjänster",
      "siding_pro": "Ytterpanel",
      "smart_home": "Smarta hemtjänster",
      "snow_removal": "Snöröjningstjänster",
      "spa": "Spatjänster",
      "tax_lawyer": "Skatterätt",
      "tax_specialist": "Skattetjänster",
      "therapist": "Terapi",
      "towing_pro": "Vägassistans",
      "traffic_lawyer": "Trafiklag",
      "tree_service": "Trädtjänster",
      "tutor": "Rådgivning",
      "upholstery_cleaner": "Möbelrengöring",
      "veterinarian": "Veterinärtjänster",
      "videographer": "Videotjänster",
      "water_damage": "Vattenskadetjänster",
      "weight_loss_service": "Viktminskningstjänster",
      "window_cleaner": "Fönstertvätt",
      "window_repair": "Fönstertjänster",
      "windshield_repair_pro": "Bilglas",
      "yoga_instructor": "Yoga"
    },
    "job_types": {
      "accountant_other": "Annat",
      "bankruptcy_tax_litigation": "Skatterättsliga konkurstvister",
      "bookkeeping": "Bokföring",
      "business_consulting": "Företagskonsultation",
      "debt_collection_relief": "Inkassohjälp",
      "irs_representation_resolution": "IRS-representation och -lösning",
      "payroll": "Löner",
      "tax_planning_business": "Skatteplanering för företag",
      "tax_planning_individual": "Skatteplanering för privatperson",
      "tax_return_business": "Skattedeklaration för företag",
      "tax_return_individual": "Skattedeklaration för privatperson",
      "trusts_estates_accounting": "Trusts och fastighetsredovisning",
      "acupressure": "Akupressur",
      "acupuncture": "Akupunktur",
      "acupuncturist_other": "Annat",
      "cupping": "Koppning",
      "gua_sha": "Gua Sha",
      "heat_therapy": "Värmebehandling",
      "herbal_therapy": "Örtbehandling",
      "infrared_therapy": "Infraröd terapi",
      "moxibustion": "Moxibustion",
      "qigong": "Qigong",
      "shiatsu": "Shiatsu",
      "tui_na": "Tui Na",
      "air_duct_cleaning": "Rengöring av ventilationskanaler",
      "air_duct_filter_replacement": "Filterbyte",
      "air_duct_other": "Annat",
      "dryer_vent_cleaning": "Rengöring av torktumlarventilation",
      "furnace_cleaning": "Rengöring av ugn",
      "indoor_air_quality_testing": "Testning av luftkvalitet inomhus",
      "alcohol_treatment_other": "Annat",
      "animal_shelter_cat_adoption": "Kattadoption",
      "animal_shelter_dog_adoption": "Hundadoption",
      "animal_shelter_other": "Annat",
      "animal_shelter_other_animal_adoption": "Adoption av övriga djur",
      "animal_shelter_other_veterinary_services": "Övriga veterinärtjänster",
      "animal_shelter_spay_neuter": "Sterilisera eller kastrera",
      "animal_shelter_vaccinations": "Vaccinationer",
      "lost_stray_found_animals": "Borttappade, herrelösa eller upphittade djur",
      "pet_license": "Husdjurslicens",
      "pet_surrender": "Överlåtelse av husdjur",
      "appliance_other": "Annat",
      "repair_dishwasher": "Reparera diskmaskinen",
      "repair_dryer": "Reparera torktumlare",
      "repair_freezer": "Reparera frysen",
      "repair_microwave": "Reparation av mikrovågsugn",
      "repair_oven": "Reparera ugnen",
      "repair_refrigerator": "Reparera kylskåp",
      "repair_refrigerator_freezer": "Reparera kylskåp / frys",
      "repair_stove_cooktop": "Reparera spis/spishäll",
      "repair_stove_cooktop_oven": "Reparera spis/spishäll/ugn",
      "repair_washer": "Reparationsbricka",
      "repair_washer_dryer": "Reparera tvättmaskin / torktumlare",
      "3d_architectural_rendering": "3D-arkitektonisk rendering",
      "adaptive_reuse_historical_renovation": "Adaptiv återanvändning & historisk renovering",
      "architect_other": "Annat",
      "architectural_designing": "Arkitektonisk design",
      "architectural_engineering": "Arkitektonisk ingenjörskonst",
      "building_code_analysis_permit_coordination": "Kodanalys och tillstånd",
      "consulting": "Konsultation",
      "home_building_improvement": "Hembyggnation och förbättring",
      "interior_design_architect": "Inredningsdesign",
      "planning_zoning_approval_assistance": "Planering och zonindelningsgodkännande",
      "project_managing_architect": "Projektledning",
      "site_master_planning": "Platsplanering",
      "assisted_living_housekeeping_and_laundry": "Hushållning och tvätt",
      "assisted_living_meal_services": "Måltidstjänster",
      "assisted_living_memory_care": "Minnesvård",
      "assisted_living_other": "Annat",
      "assisted_living_rehabilitation_services": "Rehabiliteringstjänster",
      "assisted_living_transportation": "Transport",
      "assisted_living_wellness_programs": "Wellnessprogram",
      "daily_living_assistance": "Dagligt livsstöd",
      "medication_management": "Läkemedelshantering",
      "short_term_stays": "Korttidsboenden",
      "social_and_recreational_activities": "Fritidsaktiviteter",
      "babysitter_other": "Annat",
      "event_babysitting": "Barnpassning vid evenemang",
      "homework_assistance": "Läxhjälp",
      "housekeeping_laundry": "Hushållning och tvätt",
      "meal_preparation": "Förberedelse av måltid",
      "nanny_services": "Nannytjänster",
      "overnight_babysitting": "Barnpassning över natten",
      "pick_up_and_drop_off": "Hämtning och lämning",
      "shopping_errand": "Shopping och ärenden",
      "special_needs_care": "Specialvård för särskilda behov",
      "virtual_babysitting": "Virtuell barnpassning",
      "agriculture_bankruptcy": "Jordbrukskonkurs",
      "bankruptcy_lawyer_other": "Annat",
      "bankruptcy_litigation": "Konkursprocesser",
      "chapter_11_bankruptcy": "Kapitel 11 Konkurs",
      "chapter_13_bankruptcy": "Kapitel 13 Konkurs",
      "chapter_7_bankruptcy": "Kapitel 7 Konkurs",
      "corporate_bankruptcy": "Företagskonkurs",
      "creditor_harassment": "Trakasserier av borgenärer",
      "debt_settlement": "Skuldförlikning",
      "foreclosure_bankruptcy_lawyer": "Utmätning",
      "personal_bankruptcy": "Personlig konkurs",
      "repossession": "Återtagande av egendom",
      "wage_garnishment": "Löneutmätning",
      "beauty_school_barbering": "Barbering",
      "beauty_school_business_management": "Företagshantering",
      "beauty_school_cosmetology": "Kosmetologi",
      "beauty_school_esthetics": "Estetik",
      "beauty_school_hair_cutting": "Hårklippning",
      "beauty_school_hair_design": "Hårdesign",
      "beauty_school_makeup": "Smink",
      "beauty_school_massage_therapy": "Massagebehandling",
      "beauty_school_nail_technology": "Nagelteknologi",
      "beauty_school_other": "Annat",
      "beauty_school_retail_training": "Detaljhandelskurs",
      "banking_finance_law": "Bankverksamhet och finans",
      "business_lawyer_other": "Annat",
      "business_licenses_permits": "Företagslicenser och tillstånd",
      "business_litigation": "Affärstvister",
      "business_taxes": "Skatter och avgifter för företag",
      "business_transactions_business_lawyer": "Affärstransaktioner",
      "commercial_bankruptcy": "Företagskonkurs",
      "commercial_contracts_business_lawyer": "Kommersiella kontrakt",
      "employment_law_business_lawyer": "Arbetsrätt",
      "incorporation_restructuring": "Bolagsbildning och omstrukturering",
      "insurance_law": "Försäkringsrätt",
      "intellectual_property_law": "Immaterialrätt",
      "mergers_acquisitions_business_lawyer": "Fusioner och förvärv",
      "partnership_agreements_business_lawyer": "Partnerskapsavtal",
      "patents_copyrights_trademarks": "Patent, upphovsrätter och varumärken",
      "securities_law": "Värdepappersrätt",
      "shareholder_disputes": "Aktieägartvister",
      "air_and_cabin_filter": "Luft- och kupéfilter",
      "battery": "Batteri",
      "body_and_trim": "Kaross och utrustning",
      "brakes": "Bromsar",
      "car_air_conditioning": "Luftkonditionering",
      "car_electrical": "Elektrisk",
      "car_repair_other": "Annat",
      "check_engine_light_diagnostic": "Diagnostik för lysande motorlampa",
      "exhaust": "Avgasrör",
      "oil_change": "Oljebyte",
      "steering_suspension": "Styrning/fjädring",
      "tires": "Däck",
      "transmission": "Transmission",
      "cabinetry": "Skåp",
      "carpenter_other": "Annat",
      "decking": "Terrasser",
      "drywalling": "Gipsskivor",
      "fencing": "Inhägnad",
      "general_installations": "Allmänna installationer",
      "general_repairs_maintenance": "Allmänna reparationer och underhåll",
      "remodeling": "Ombyggnad",
      "shelving_storage": "Hyllor och förvaring",
      "carpet_cleaning_other": "Annat",
      "clean_area_rugs": "Rengör mattbelagda områden",
      "clean_carpet": "Rengör matta",
      "clean_drapes_and_curtains": "Rena draperier och gardiner",
      "clean_upholstery": "Rengör möbelklädsel",
      "remove_pet_stains_and_odors": "Ta bort fläckar och lukter från husdjur",
      "after_school_care": "Omsorg efter skolan",
      "all_hours_daycare": "Dagis dygnet runt",
      "bilingual_daycare": "Tvåspråkig förskola",
      "child_care_other": "Annat",
      "drop_in_daycare": "Drop-in-förskola",
      "full_time_daycare": "Heltidsförskola",
      "in_home_daycare": "Hemvård för barn",
      "infant_programs": "Program för spädbarn",
      "part_time_daycare": "Daghem på deltid",
      "pre_kindergarten_programs": "Program för förskolebarn",
      "preschool_programs": "Förskoleprogram",
      "school_age_programs": "Program för skolbarn",
      "special_needs_daycare": "Daghem för barn med särskilda behov",
      "summer_daycare": "Sommardagis",
      "toddler_programs": "Småbarnsprogram",
      "weekend_daycare": "Helgdagis",
      "chiropractor_acupuncture": "Akupunktur",
      "chiropractor_chiropractic": "Kiropraktik",
      "chiropractor_massage_therapy": "Massagebehandling",
      "chiropractor_other": "Annat",
      "diagnosis": "Diagnos",
      "eastern_medicine": "Österländsk medicin",
      "exercise_counseling": "Rådgivning om träning",
      "pain_management": "Smärthantering",
      "physical_therapy": "Fysioterapi",
      "spinal_adjustments": "Ryggradsjusteringar",
      "sports_medicine": "Idrottsmedicin",
      "cleaner_other": "Annat",
      "deep_clean": "Djupstädning",
      "moving_clean": "Flyttstädning",
      "office_clean": "Kontorsstädning",
      "standard_clean": "Standardstädning",
      "assignment_of_contract": "Överlåtelse av kontrakt",
      "business_transactions_contract_lawyer": "Affärstransaktioner",
      "commercial_contracts_contract_lawyer": "Kommersiella kontrakt",
      "contract_dispute": "Avtalskonflikt",
      "contract_lawyer_other": "Annat",
      "contract_negotiation": "Avtalsförhandling",
      "contract_review": "Kontraktgranskning",
      "employment_contracts_contract_lawyer": "Anställningskontrakt",
      "franchise_agreements": "Franchiseavtal",
      "mergers_acquisitions_contract_lawyer": "Fusioner och förvärv",
      "non_disclosure_agreements_contract_lawyer": "Sekretessavtal",
      "partnership_agreements_contract_lawyer": "Partnerskapsavtal",
      "power_of_attorney_contract_lawyer": "Fullmakt",
      "security_agreements": "Säkerhetsavtal",
      "warranties": "Garantier",
      "bathroom_countertops": "Badrumsbänkskivor",
      "bathroom_wall_panels": "Badrumsväggpaneler",
      "countertop_design": "Bänkskivedesign",
      "countertop_installation": "Bänkskiveinstallation",
      "countertop_pro_other": "Annat",
      "fireplace_facade": "Eldstadsfasad",
      "granite_countertops": "Bänkskivor i granit",
      "kitchen_countertops": "Köksbänkskivor",
      "kitchen_wall_panels": "Köksväggpaneler",
      "laminate_countertops": "Laminatbänkskivor",
      "marble_countertops": "Marmorbänkskivor",
      "quartz_countertops": "Kvartsbänkskivor",
      "remodeling_countertop_pro": "Ombyggnad",
      "repair_maintenance_countertop_pro": "Reparation och underhåll",
      "stone_slab_countertops": "Stenbänkskivor",
      "tile_countertops": "Kakelbänkskivor",
      "corporate_representation": "Företagsrepresentation",
      "criminal_immigration_defense": "Försvarare vid olaglig invandring",
      "criminal_lawyer_other": "Annat",
      "domestic_violence": "Våld i nära relationer",
      "drug_possession": "Droginnehav",
      "duis_reckless_driving": "Rattfylleri & vårdslös körning",
      "expungement": "Radering",
      "federal_crimes": "Federala brott",
      "felonies": "Brott",
      "petty_crimes_misdemeanors": "Småbrott och förseelser",
      "restraining_orders": "Besöksförbud",
      "sex_offenses": "Sexualbrott",
      "three_strikes_law": "Tre-strejkslagen",
      "dance_instructor_african": "Afrikansk",
      "dance_instructor_ballet": "Balett",
      "dance_instructor_ballroom": "Balsal",
      "dance_instructor_belly": "Mage",
      "dance_instructor_bollywood": "Bollywood",
      "dance_instructor_contemporary": "Modern",
      "dance_instructor_folk_traditional": "Folklig och traditionell",
      "dance_instructor_hip_hop": "Hip Hop",
      "dance_instructor_jazz": "Jazz",
      "dance_instructor_kids_classes": "Barnkurser",
      "dance_instructor_latin": "Latin",
      "dance_instructor_modern": "Modern",
      "dance_instructor_other": "Annat",
      "dance_instructor_tap": "Tryck på",
      "dance_instructor_wedding": "Bröllop",
      "disability_hearings": "Funktionsnedsättningsbedömning",
      "disability_lawyer_other": "Annat",
      "long_term_disability": "Långvarig funktionsnedsättning",
      "short_term_disability": "Kortvarig funktionsnedsättning",
      "social_security_disability_insurance": "Socialförsäkring för invaliditet",
      "ssa_claim_reconsideration": "Omprövning av SSA-krav",
      "ssa_disability_appeals": "Överklaganden av SSA-funktionshinder",
      "ssa_disability_applications": "Ansökningar om SSA-funktionshinder",
      "ssa_disability_benefits": "Förmåner för SSA-funktionshinder",
      "ssa_family_benefits": "SSA-förmåner för familjer",
      "ssa_impairment_listings": "Listor av SSA-funktionshinder",
      "supplemental_security_income": "Tilläggsskyddsinkomst",
      "veterans_disability_benefits": "Handikappförmåner för veteraner",
      "workers_compensation_disability_lawyer": "Arbetsskadeersättning",
      "behind_the_wheel_lessons": "Körlektioner",
      "commercial_license_training": "Kommersiell licensutbildning",
      "defensive_driving_lessons": "Kurs i defensiv körning",
      "drivers_education_classes": "Förarutbildningskurser",
      "driving_instructor_other": "Annat",
      "manual_transmission_lessons": "Lektioner i manuell hantering",
      "motorcycle_lessons": "Motorcykellektioner",
      "traffic_school": "Trafikskola",
      "dui_dwi_dui_lawyer": "Drograttfylla/rattfylla",
      "dui_injuries_dui_lawyer": "Rattfylla med skada",
      "dui_lawyer_other": "Annat",
      "dui_with_accident": "Rattfylleri med olycka",
      "felony_dui": "Grovt rattfylleri",
      "invalid_tests": "Ogiltiga tester",
      "multiple_offenses": "Flera överträdelser",
      "reckless_driving_dui_lawyer": "Vårdslös körning",
      "underage_dui": "Rattfylleri för underåriga",
      "electric_car_charger": "Installera laddstation för elbil",
      "electrician_other": "Annat",
      "electrician_remodeling": "Ombyggnad",
      "install_fan": "Installera fläkt",
      "install_ground_wire": "Installera jordledning",
      "install_light_fixtures": "Installera belysningsarmaturer",
      "install_outdoor_lighting": "Installera utomhusbelysning",
      "install_outlets_switches": "Installera uttag eller strömbrytare",
      "install_security_system": "Installera säkerhetssystem",
      "relocate_outlets_switches": "Flytta uttag eller strömbrytare",
      "repair_fan": "Reparation av fläkt",
      "repair_light_fixtures": "Reparation av belysningsarmaturer",
      "repair_outlets_switches": "Reparera uttag eller strömbrytare",
      "repair_panel": "Reparation av panel",
      "replace_upgrade_panel": "Ersätt eller uppgradera panel",
      "restore_power": "Återställ ström",
      "energy_efficiency_pro_other": "Annat",
      "charitable_giving": "Välgörenhet",
      "contests_litigation": "Tvister/rättstvister",
      "deeds": "Åtgärder",
      "estate_lawyer_other": "Annat",
      "estate_planning_lawyer": "Fastighetsplanering",
      "guardianship_estate_lawyer": "Förmyndarskap",
      "medical_power_of_attorney": "Medicinsk fullmakt",
      "power_of_attorney_estate_lawyer": "Fullmakt",
      "probate_estate_lawyer": "Bouppteckningsadvokat",
      "trusts": "Trusts",
      "wills": "Testamenten",
      "anniversary_planner": "Årsdag",
      "baby_shower_planner": "Babyshower",
      "bar_and_bat_mitzvah_planner": "Bar och Bat Mitzvah",
      "birthday_party": "Födelsedagsfest",
      "children_party": "Barnkalas",
      "corporate_and_conference_planner": "Företags- och konferensverksamhet",
      "event_planner_other": "Annat",
      "quinceanera_planner": "Quinceanera",
      "religious_event": "Religiöst evenemang",
      "retirement_party": "Pensionsfest",
      "school_event": "Skolevenemang",
      "theme_party": "Temafest",
      "wedding_and_engagement_planner": "Bröllop och förlovning",
      "adoption": "Adoption",
      "child_support": "Underhållsbidrag",
      "contested_divorce": "Bestridd skilsmässa",
      "debt_division": "Skulduppdelning",
      "family_lawyer_other": "Annat",
      "guardianship_family_lawyer": "Förmyndarskap",
      "mediation_family_lawyer": "Medling",
      "modifications_of_orders": "Ändring av ordrar",
      "parent_timesharing": "Föräldratidshantering",
      "paternity": "Faderskap",
      "prenuptial_postnuptial_agreements": "Äktenskapsförord & äktenskapsavtal",
      "probate_family_lawyer": "Bouppteckning",
      "property_divisions": "Egendomsdelning",
      "protective_orders_domestic_violence_issues": "Besöksförbud",
      "spousal_support_alimony": "Underhållsbidrag",
      "uncontested_divorce": "Obestridd skilsmässa",
      "custom_construction": "Anpassad konstruktion",
      "fence_design": "Staketdesign",
      "fencing_other": "Annat",
      "installation_fencing_pro": "Staketinstallation",
      "repairs_maintenance_fencing_pro": "Reparationer och underhåll",
      "education_savings": "Utbildningssparande",
      "estate_financial_planning": "Fastighetsplanering",
      "financial_planning": "Finansiell planering",
      "financial_planning_other": "Annat",
      "home_purchase": "Husköp",
      "insurance": "Försäkring",
      "investment_advising": "Investeringsrådgivning",
      "retirement_savings": "Pensionering",
      "tax_planning": "Skatteplanering",
      "advanced_cardiac_life_support": "Avancerat hjärtlivsstöd",
      "aed_defibrillator": "AED - Defibrillator",
      "basic_life_support": "Grundläggande livräddning",
      "cpr": "HLR",
      "first_aid": "Första hjälpen",
      "first_aid_trainer_other": "Annat",
      "pediatric_advanced_life_support": "Avancerad livsuppehållande behandling för barn",
      "pediatric_cpr_first_aid": "Hjärt-lungräddning och första hjälpen för barn",
      "pet_cpr_first_aid": "Hjärt-lungräddning och första hjälpen för husdjur",
      "wilderness_first_aid": "Första hjälpen i vildmarken",
      "baseboards": "Basplattor",
      "carpet": "Matta",
      "flooring_other": "Annat",
      "hardwood": "Hårdträ",
      "installation_flooring_pro": "Installera golv",
      "marble": "Marmor",
      "polishing": "Golvpolering",
      "refinishing": "Golvslipning och ytbehandling",
      "repair_maintenance_flooring_pro": "Reparation och underhåll av golv",
      "stair_flooring": "Trappgolv",
      "tile": "Kakel",
      "wood_floor_sanding": "Slipning av trägolv",
      "basement_waterproofing": "Vattentätning i källare",
      "crawl_spaces": "Krypgrundsfundament",
      "foundation_drainage": "Grunddränering",
      "foundation_installation": "Installation av grund",
      "foundation_pro_other": "Annat",
      "foundation_raising": "Höjning av grund",
      "repairs_maintenance_foundation_pro": "Reparationer och underhåll",
      "slab_foundation": "Plattfundament",
      "steel_pier_pilings": "Stålpålar för pir",
      "water_moisture_control": "Vatten- och fuktkontroll",
      "burials": "Begravningar",
      "caskets": "Kistor",
      "cremation": "Kremering",
      "funeral_home_flowers": "Blommor",
      "funeral_home_other": "Annat",
      "funeral_home_transportation_transfers": "Transport och överföringar",
      "funeral_home_veteran_services": "Veterantjänster",
      "funerals": "Begravningar",
      "gravestones": "Gravstenar",
      "grief_services": "Sorgtjänster",
      "memorials": "Minnestjänst",
      "urns": "Urnor",
      "garage_door_other": "Annat",
      "general_maintenance": "Allmänt underhåll",
      "install_garage_door": "Installera garageport",
      "install_opener": "Installera öppnare",
      "repair_cables": "Reparation av kablar",
      "repair_garage_door": "Reparation av garageport",
      "repair_gate": "Reparation av grind",
      "repair_rollers_tracks": "Reparera rullar och spår",
      "replace_door_panels": "Ersätt dörrpaneler",
      "replace_opener": "Ersätt öppnare",
      "replace_springs": "Ersätt fjädrar",
      "accessory_buildings": "Komplementbyggnader",
      "bathroom_remodel": "Badrumsrenovering",
      "decks_patio": "Terrasser och uteplatser",
      "exterior_finishing": "Fasadarbete",
      "foundations_concrete": "Grund och betong",
      "general_contractor_commercial_projects": "Kommersiella projekt",
      "general_contractor_other": "Annat",
      "home_addition": "Tillbyggnad av hem",
      "home_building": "Husbyggnad",
      "home_remodel_renovation": "Hemrenovering och ombyggnad",
      "interior_finishing": "Interiörarbete",
      "kitchen_remodel": "Köksrenovering",
      "roofing": "Takläggning",
      "assemble_furniture": "Montera möbler",
      "clean_gutters": "Rengör hängrännor",
      "handyman_other": "Annat",
      "install_drywall": "Installera gipsskiva",
      "install_flooring": "Installera golv",
      "install_tile": "Installera kakel",
      "install_water_fixtures": "Installera vattenarmaturer",
      "mount_tv": "Montera TV",
      "paint_indoors": "Måla inomhus",
      "paint_outdoors": "Måla utomhus",
      "repair_drywall": "Reparera gipsvägg",
      "repair_flooring": "Reparation av golv",
      "repair_water_fixtures": "Reparera vatteninstallationer",
      "replace_tile": "Ersätt kakel",
      "buyer_seller_inspection": "Köpar- och säljarbesiktning",
      "commercial_properties": "Kommersiella fastigheter",
      "fire_safety": "Brandsäkerhet",
      "fireplace_chimney": "Eldstad och skorsten",
      "full_home_inspection": "Fullständig hembesiktning",
      "home_inspector_electrical": "Elektrisk",
      "home_inspector_foundation": "Fundament",
      "home_inspector_hvac": "HVAC",
      "home_inspector_mold": "Mögel",
      "home_inspector_new_construction": "Nybyggnation",
      "home_inspector_other": "Annat",
      "home_inspector_plumbing": "Rörmokeri",
      "home_inspector_roof": "Tak",
      "home_inspector_structural": "Strukturell",
      "home_warranty": "Hemgaranti",
      "water_testing": "Vattentestning",
      "well_or_septic_system": "Brunns- eller septiksystem",
      "wood_insects": "Trä och insekter",
      "access_control": "Åtkomstkontroll",
      "alarm_systems": "Larmsystem",
      "commercial_security_systems": "Kommersiella säkerhetssystem",
      "fire_smoke_detection": "Brand- och rökdetektering",
      "home_security_doors": "Dörrar",
      "home_security_locks": "Lås",
      "home_security_other": "Annat",
      "home_security_windows": "Fönster",
      "monitoring_services": "Övervakningstjänster",
      "residential_security_systems": "Bostadssäkerhetssystem",
      "smart_home_integration": "Smart hemintegration",
      "video_surveillance": "Videoövervakning",
      "audio_video_installation": "Installation av ljud och video",
      "commercial_projects": "Kommersiella projekt",
      "home_theater_design": "Styling av hemmabio",
      "home_theater_lighting": "Belysning",
      "home_theater_other": "Annat",
      "home_theater_smart_home_integration": "Smart hemintegration",
      "install_tv": "Installera TV:n",
      "network_it_services": "System och IT-Tjänster",
      "outdoor_installations": "Utomhusinstallationer",
      "soundproofing": "Ljudisolering",
      "whole_house_audio_video": "Ljud och video för hela huset",
      "ac_maintenance": "AC-underhåll",
      "clean_ducts_vents": "Rengör kanaler och ventiler",
      "ductless_heating_and_ac_services": "Kanallösa värme- och AC-tjänster",
      "heating_maintenance": "Underhåll av värmesystem",
      "hvac_maintenance": "HVAC-underhåll",
      "hvac_other": "Annat",
      "install_ac": "Installera AC",
      "install_ducts_vents": "Installera kanaler och ventiler",
      "install_heating_system": "Installera värmesystem",
      "install_thermostat": "Installera termostat",
      "repair_ac": "Reparera AC",
      "repair_ducts_vents": "Reparera kanaler och ventiler",
      "repair_heating_system": "Reparation av värmesystem",
      "repair_hvac": "Reparera HVAC",
      "repair_thermostat": "Reparation av termostat",
      "asylum": "Asyl",
      "citizenship": "Medborgarskap",
      "deportation": "Deportation",
      "family_based_immigration": "Familjebaserad invandring",
      "green_card": "Green Card",
      "immigration_lawyer_other": "Annat",
      "investment_visa": "Investeringsvisum",
      "outbound_work_permits": "Utgående arbetstillstånd",
      "student_visa": "Studentvisum",
      "visitor_visa": "Besöksvisum",
      "work_visa": "Arbetsvisum",
      "appliance_selection": "Val av vitvaror",
      "cabinetry_molding_hardware_design": "Skåp- och hårdvarudesign",
      "decorating": "Dekoration",
      "door_design": "Dörrdesign",
      "exterior_building_design": "Exteriör byggnadsdesign",
      "flooring_selection": "Val av golv",
      "interior_designer_other": "Annat",
      "landscaping_design": "Landskapsdesign",
      "lighting_design": "Belysningsdesign",
      "multifamily_housing_design": "Design av flerfamiljshus",
      "room_planning": "Rumsplanering",
      "stone_brick_stucco_design": "Sten, tegel och stuckaturstyling",
      "window_design": "Fönsterdesign",
      "advertisements": "Reklam",
      "copyright": "Upphovsrätt",
      "export_control": "Exportkontroll",
      "franchises": "Franchisetagare",
      "international_ip": "Internationell IP",
      "ip_lawyer_other": "Annat",
      "ip_strategy": "IP-strategi",
      "ip_transactions": "IP-transaktioner",
      "licensing": "Licensiering",
      "litigation_ip_lawyer": "Rättstvist",
      "non_disclosure_agreements_ip_lawyer": "Sekretessavtal",
      "patents": "Patent",
      "technology_transfer": "Tekniköverföring",
      "trade_secrets": "Affärshemligheter",
      "trademarks": "Varumärken",
      "appliance_removal": "Borttagning av apparater",
      "construction_waste_removal": "Borttagning av byggavfall",
      "donation_pickup": "Hämtning av donationer",
      "electronic_waste_removal": "Borttagning av elektroniskt avfall",
      "furniture_removal": "Borttagning av möbler",
      "general_junk_removal": "Allmän borttagning av skräp",
      "hazardous_waste_removal": "Borttagning av farligt avfall",
      "house_garage_cleanout": "Rensning av hus/garage",
      "junk_removal_other": "Annat",
      "yard_waste_removal": "Borttagning av trädgårdsavfall",
      "employment_contracts_labor_lawyer": "Anställningskontrakt",
      "employment_law_labor_lawyer": "Arbetsrätt",
      "exempt_employee_status": "Status som undantagen anställd",
      "labor_law": "Arbetsrätt",
      "labor_lawyer_other": "Annat",
      "labor_negotiations": "Förhandlingar om arbetsvillkor",
      "privacy_rights": "Integritetsrättigheter",
      "sexual_harassment": "Sexuella trakasserier",
      "unpaid_overtime": "Obetald övertid",
      "whistle_blowing": "Visselblåsning",
      "workers_compensation_labor_lawyer": "Arbetsskadeersättning",
      "wrongful_termination": "Ogrundad uppsägning",
      "artificial_turf_installation": "Installation av konstgräs",
      "concrete_masonry": "Betongmurning",
      "driveway_landscaping": "Landskapsarkitektur för uppfart",
      "garden_decorations": "Trädgårdsdekorationer",
      "grading_resloping": "Markberedning och omformning",
      "hardscapes": "Hårdgjorda ytor",
      "landscape_design": "Landskapsdesign",
      "landscape_installations": "Landskapsinstallationer",
      "landscaper_other": "Annat",
      "outdoor_steps": "Utomhustrappor",
      "outdoor_water_feature": "Vattenfunktioner utomhus",
      "paving_driveway_walkway": "Asfaltering av uppfart eller gångväg",
      "retaining_walls": "Stödmurar",
      "sidewalk_walkway_landscaping": "Landskapsarkitektur för gångväg",
      "sod_seeding": "Gräsmatta & Sådd",
      "stone_masonry": "Stenverk",
      "arabic": "Arabic",
      "english": "English",
      "french": "French",
      "german": "German",
      "hebrew": "Hebreiska",
      "italian": "Italian",
      "japanese": "Japanese",
      "korean": "Korean",
      "language_instructor_other": "Annat",
      "mandarin": "Mandarin",
      "portuguese": "Portugisiska",
      "russian": "Russian",
      "sign_language": "Teckenspråk",
      "spanish": "Spanish",
      "irrigation_system_repair_maintenance": "Reparation och underhåll av bevattningssystem",
      "lawn_care_other": "Annat",
      "lawn_mowing_maintenance": "Gräsklippning / Underhåll",
      "lawn_pest_control": "Skadedjursbekämpning av gräsmatta",
      "mulching": "Täckodling",
      "seeding": "Sådd",
      "sod_installation": "Torvinstallation",
      "weed_control": "Ogräsbekämpning",
      "yard_cleanup": "Trädgårdsstädning",
      "appeals": "Överklaganden",
      "case_assessment_litigation_lawyer": "Fallbedömning",
      "civil_litigation": "Civilrättsliga tvister",
      "commercial_litigation": "Kommersiell rättstvist",
      "contracts_and_agreements": "Avtal och överenskommelser",
      "criminal_litigation": "Straffrättsliga tvister",
      "litigation_lawyer_other": "Annat",
      "mediation_litigation_lawyer": "Medling",
      "settlements": "Avräkningar",
      "building_lockout": "Utelåsning av byggnad",
      "copy_building_key": "Kopiera byggnadsnycklar",
      "copy_vehicle_key": "Kopiera fordonsnyckel",
      "install_hardware": "Installera hårdvara",
      "locksmith_other": "Annat",
      "new_key_fob": "Ny nyckelbricka",
      "rekey_lock": "Byt låscylinder",
      "repair_hardware": "Reparera hårdvara",
      "vehicle_lockout": "Utelåsning av fordon",
      "consent_issues": "Samtyckesproblem",
      "diagnosis_errors": "Diagnosfel",
      "malpractice_lawyer_other": "Annat",
      "medical_negligence": "Medicinsk försummelse",
      "treatment_errors": "Behandlingsfel",
      "massage_center_other": "Annat",
      "massage_school_advanced_neuromuscular_therapy": "Avancerad neuromuskulär terapi",
      "massage_school_business_and_ethics": "Företag och etik",
      "massage_school_clinical_therapies": "Kliniska behandlingar",
      "massage_school_continuing_education": "Vidareutbildning",
      "massage_school_deep_tissue_massage": "Djupvävnadsmassage",
      "massage_school_energetics": "Energi",
      "massage_school_hydrotherapy": "Hydroterapi",
      "massage_school_lymphatic_massage": "Lymfdränagemassage",
      "massage_school_online_massage_therapy": "Online massageterapi",
      "massage_school_other": "Annat",
      "massage_school_prenatal_massage": "Gravidmassage",
      "massage_school_sports_massage": "Idrottsmassage",
      "massage_school_student_massage_clinic": "Studentmassageterapi",
      "massage_school_swedish_massage": "Svensk massage",
      "massage_theory": "Massageteori",
      "massage_therapy_training": "Kurser i massageterapi",
      "in_state_move": "Flytt inom delstat",
      "local_move": "Lokal flytt",
      "mover_other": "Annat",
      "moving_junk_removal": "Borttagning av skräp",
      "moving_storage": "Förvaring",
      "out_of_state_move": "Flytt utanför delstat",
      "oversized_item_move": "Flytt av överdimensionerat föremål",
      "packing_unpacking": "Packning/uppackning",
      "senior_move": "Seniorflytt",
      "vehicle_transport": "Fordonstransport",
      "cardiac_care": "Hjärtsjukvård",
      "general_medical_care": "Allmän medicinsk vård",
      "hospice": "Hospice",
      "iv_therapy": "IV-terapi",
      "nursing_home_meal_services": "Måltidstjänster",
      "nursing_home_memory_care": "Minnesvård",
      "nursing_home_other": "Annat",
      "nursing_home_pain_management": "Smärthantering",
      "nursing_home_rehabilitation_services": "Rehabiliteringstjänster",
      "nursing_home_wellness_programs": "Wellnessprogram",
      "outpatient_rehabilitation": "Öppenvårdsrehabilitering",
      "post_hospital_care": "Eftervård efter sjukhusvistelse",
      "respiratory_and_pulmonary_care": "Andnings- och lungvård",
      "senior_activity_programs": "Aktivitetsprogram för seniorer",
      "short_term_rehabilitation": "Korttidsrehabilitering",
      "wound_care": "Sårvård",
      "exterior_painting": "Målning av exteriör",
      "interior_painting": "Målning av interiör",
      "paint_cabinets": "Måla skåp",
      "paint_doors": "Måla dörrar",
      "painter_other": "Annat",
      "repair_water_damage": "Reparera vattenskada",
      "staining": "Färgning",
      "assault_battery": "Angrepp och misshandel",
      "auto_accidents": "Bilolyckor",
      "bicycle_accidents": "Cykelolyckor",
      "catastrophic_injuries": "Katastrofala skador",
      "dog_bites": "Hundbett",
      "dui_injuries_personal_injury_lawyer": "Skador från rattfylleri",
      "medical_malpractice": "Medicinsk felbehandling",
      "motorcycle_accidents": "Motorcykelolyckor",
      "pain_suffering": "Smärta och lidande",
      "pedestrian_accidents": "Fotgängarolyckor",
      "personal_injury_lawyer_other": "Annat",
      "product_liability": "Produktansvar",
      "slip_fall": "Halkolycka",
      "uninsured_motorist_claims": "Trafikförsäkringsanspråk",
      "workers_compensation_personal_injury_lawyer": "Arbetsskadeersättning",
      "wrongful_death": "Felaktig död",
      "aerobics": "Aerobics",
      "athletic_performance": "Prestation inom idrott",
      "circuit_training": "Kretsträning",
      "endurance": "Uthållighet",
      "fitness_assessment": "Konditionsbedömning",
      "hiit": "HIIT",
      "nutritional_counseling": "Kostrådgivning",
      "personal_trainer_other": "Annat",
      "strength_conditioning": "Styrka och konditionsträning",
      "weight_loss": "Viktminskning",
      "yoga": "Yoga",
      "ants": "Myror",
      "bed_bugs": "Vägglöss",
      "bees": "Bin",
      "cockroaches": "Kackerlackor",
      "fleas_or_mites": "Loppor eller kvalster",
      "hornets_or_wasps": "Getingar",
      "mosquitoes": "Myggor",
      "pest_control_other": "Annat",
      "pest_inspection": "Inspektion",
      "rodents": "Gnagare",
      "spiders": "Spindlar",
      "termites": "Termiter",
      "wildlife": "Vilda djur och växter",
      "pet_adoption_birds": "Fåglar",
      "pet_adoption_cats": "Katter",
      "pet_adoption_dogs": "Hundar",
      "pet_adoption_farm_animals": "Jordbruksdjur",
      "pet_adoption_fish": "Fisk",
      "pet_adoption_other": "Annat",
      "pet_adoption_reptiles": "Reptiler",
      "pet_adoption_small_mammals": "Små däggdjur",
      "pet_adoption_special_needs_animals": "Djur med särskilda behov",
      "cat_boarding": "Kattpensionat",
      "cat_grooming": "Kattskötsel",
      "cat_sitting_in_home": "Kattpassning (i hemmet)",
      "dog_boarding": "Hundpensionat",
      "dog_boarding_with_training": "Hundpensionat med kurser",
      "dog_daycare": "Hunddagis",
      "dog_grooming": "Hundskötsel",
      "dog_sitting_in_home": "Hundpassning (i hemmet)",
      "dog_training": "Hundträning",
      "dog_walking": "Hundpromenad",
      "other_pet_boarding": "Övrigt husdjurspensionat",
      "other_pet_daycare": "Övrigt dagis för husdjur",
      "other_pet_grooming": "Övrig djurskötsel",
      "other_pet_sitting_in_home": "Övrig djurpassning (i hemmet)",
      "pet_boarding_other": "Annat",
      "cat_bathing": "Kattbad",
      "cat_ear_cleaning": "Rengöring av kattöron",
      "cat_grooming_and_styling": "Kattvård och styling",
      "cat_nail_trimming": "Kattnagelklippning",
      "dog_anal_gland_expression": "Analkörtelutfall för hund",
      "dog_bathing_and_blow_dry": "Hundbad och föning",
      "dog_ear_cleaning": "Hundöronrengöring",
      "dog_flea_and_tick_treatment": "Hundlopps- och fästingbehandling",
      "dog_full_service_grooming": "Hundvård med full service",
      "dog_grooming_and_styling": "Hundvård och styling",
      "dog_nail_trimming": "Hundkloklippning",
      "dog_teeth_brushing": "Hundtandsrengöring",
      "pet_grooming_other": "Annat",
      "aggressive_dog_training": "Kurser för aggressiva hundar",
      "behavior_modification": "Beteendemodifikation",
      "obedience_training": "Lydnadsträning",
      "offleash_training": "Kurser utan koppel",
      "pet_trainer_other": "Annat",
      "puppy_training": "Valpträning",
      "service_animal_training": "Kurser för assistansdjur",
      "sport_trick_training": "Sport- eller trickträning",
      "training_other_animals": "Kurser för andra djur",
      "corporate_photo": "Företag",
      "events_and_parties_photo": "Evenemang och fester",
      "family_and_group_photo": "Familj och grupp",
      "headshots_and_portraits": "Porträttbilder",
      "individual_photo": "Individ",
      "maternity_and_newborn_photo": "Moderskap och nyfödd",
      "photographer_other": "Annat",
      "product_photo": "Produkt",
      "real_estate_photo": "Fastigheter",
      "school_portraits": "Skolporträtt",
      "wedding_and_engagement_photo": "Bröllop och förlovning",
      "find_leak": "Hitta och reparera läcka",
      "install_faucet": "Installera blandare",
      "install_garbage_disposal": "Installera avfallskvarn",
      "install_shower": "Installera dusch",
      "install_toilet": "Installera toalett",
      "install_water_heater": "Installera varmvattenberedare",
      "plumbing_other": "Annat",
      "repair_faucet": "Reparera kran",
      "repair_garbage_disposal": "Reparation av avfallskvarn",
      "repair_outdoor_systems": "Reparation av utomhussystem",
      "repair_pipe": "Reparera rör",
      "repair_sewer": "Reparera avlopp",
      "repair_shower": "Reparera duschen",
      "repair_toilet": "Reparera toalett",
      "repair_water_heater": "Reparera varmvattenberedaren",
      "unclog_drain": "Rensa avloppet",
      "commercial_pool_cleaning_maintenance": "Rengöring och underhåll av kommersiella pooler",
      "equipment_maintenance_repair": "Utrustningsunderhåll och reparation",
      "one_time_pool_cleaning": "Engångsrengöring av pool",
      "ongoing_pool_cleaning": "Löpande poolrengöring",
      "pool_cleaner_other": "Annat",
      "pool_cleaner_water_features": "Vattenfunktioner",
      "seasonal_opening_closing": "Säsongsöppning och stängning",
      "spa_hot_tub_cleaning": "Rengöring av spa och bubbelpooler",
      "spa_hot_tub_repairs": "Reparationer av spa och bubbelpooler",
      "tile_pool_wall_cleaning": "Rengöring av kakel och poolväggar",
      "water_testing_balancing": "Vattenanalys och balansering",
      "jetted_lap_pools": "Pooler med vattenström",
      "pool_construction": "Poolkonstruktion",
      "pool_contractor_commercial_projects": "Kommersiella projekt",
      "pool_contractor_custom_designs": "Anpassade designer",
      "pool_contractor_other": "Annat",
      "pool_contractor_renovation": "Renovering",
      "pool_contractor_repair_cracks": "Åtgärda sprickor",
      "pool_contractor_repair_tile": "Reparera kakel",
      "pool_contractor_resurfacing": "Ytskiktsrenovering",
      "pool_contractor_water_features": "Vattenfunktioner",
      "pool_hot_tub_equipment": "Utrustning för pool och badkar",
      "spa_hot_tub_installation": "Installation av spa och bubbelpool",
      "bilingual_programs": "Tvåspråkiga program",
      "early_preschool": "Förskola för yngre barn",
      "full_day_preschool": "Heldagsförskola",
      "half_day_preschool": "Halvdagsförskola",
      "kindergarten_classes": "Förskoleklasser",
      "montessori_programs": "Montessoriprogram",
      "play_based_preschool": "Lekbaserad förskola",
      "preschool_infant_programs": "Program för spädbarn",
      "preschool_other": "Annat",
      "reggio_emilia_preschool": "Reggio Emilia Förskola",
      "special_needs_programs": "Program för särskilda behov",
      "summer_camp": "Sommarläger",
      "waldorf_preschool": "Waldorf Förskola",
      "psychologist_other": "Annat",
      "buyer_agent": "Köparmäklare",
      "first_time_home_buyer": "Förstagångsköpare av hem",
      "foreclosed_properties": "Utmätning av fastigheter",
      "luxury_properties": "Lyxfastigheter",
      "new_construction": "Nybyggnation",
      "property_management": "Fastighetsförvaltning",
      "real_estate_agent_other": "Annat",
      "relocation": "Omlokalisering",
      "rentals": "Uthyrningar",
      "sellers_agent": "Säljarmäklare",
      "commercial_real_estate": "Kommersiella fastigheter",
      "easements": "Rättigheter",
      "encroachment": "Intrång",
      "foreclosure_real_esate_lawyer": "Utmätning",
      "landlord_tenant_law": "Hyresvärd- och hyresgästrätt",
      "litigation_real_estate_lawyer": "Rättstvist",
      "mortgage_lending_law": "Hypoteks- och utlåningsrätt",
      "neighbor_hoa_disputes": "Grannskaps- och HOA-tvister",
      "property_damage": "Fastighetsskada",
      "purchase_agreements": "Köpeavtal",
      "real_estate_contracts_transactions": "Fastighetsaffärer",
      "real_estate_lawyer_other": "Annat",
      "residential_real_estate": "Bostadsfastigheter",
      "title_services": "Kakeltjänster",
      "trespassing": "Olaga intrång",
      "rehab_other": "Annat",
      "attic_venting": "Vindsventilation",
      "gutter_installation": "Installation av hängrännor",
      "gutter_repair": "Reparation av hängrännor",
      "roof_inspection": "Takinspektion",
      "roof_installation": "Takinstallation",
      "roof_repair": "Takreparation",
      "roofer_other": "Annat",
      "skylight_installation": "Installation av takfönster",
      "skylight_repair": "Reparera takfönster",
      "storm_wind_damage_roof_repair": "Reparation av takskador",
      "sewage_cleaning": "Rengöring",
      "sewage_excavation": "Utgrävning",
      "sewage_inspection": "Inspektion",
      "sewage_installation": "Installation",
      "sewage_locating": "Lokalisering",
      "sewage_maintenance_repairs": "Underhåll och reparationer",
      "sewage_pro_other": "Annat",
      "sewage_pumping": "Rörmokeri",
      "sewage_removal_demolition": "Borttagning eller rivning",
      "remodeling_siding_pro": "Ombyggnad",
      "repair_maintenance_siding_pro": "Reparation och underhåll",
      "siding_installation": "Installation av fasadbeklädnad",
      "siding_pro_other": "Annat",
      "siding_removal": "Borttagning av fasad",
      "smart_home_other": "Annat",
      "commercial_snow_removal": "Snöröjning för företag",
      "residential_plowing": "Snöröjning för bostäder",
      "residential_shoveling_blowing": "Skottning och blåsning för bostäder",
      "salt_sand_deicing": "Salt, sand och avisning",
      "snow_relocation": "Snöflyttning",
      "snow_removal_other": "Annat",
      "body_polish": "Kroppspeeling",
      "body_wrap": "Kroppsinpackning",
      "facial": "Ansiktsbehandling",
      "hydrotherapy": "Hydroterapi",
      "manicure": "Manikyr",
      "massage": "Massage",
      "pedicure": "Pedikyr",
      "peels": "Skal",
      "spa_other": "Annat",
      "spa_packages": "Spa-paket",
      "tanning": "Solning",
      "waxing": "Vaxning",
      "civil_tax_litigation": "Civilrättsliga skattetvister",
      "corporate_taxes": "Företagsskatt",
      "criminal_tax_litigation": "Brottmål inom skatt",
      "estate_tax_planning": "Planering av arvsskatt",
      "failure_to_file": "Underlåtenhet att deklarera",
      "innocent_spouse_relief": "Befrielse för oskyldig make/maka",
      "international_tax_services": "Internationella skattetjänster",
      "irs_tax_problems": "IRS-skattproblem",
      "non_collectible_status": "Status som ej indrivbart",
      "offer_in_compromise": "Kompromisserbjudande",
      "tax_audits": "Skatterevisioner",
      "tax_lawyer_other": "Annat",
      "tax_liens_levies": "Skattepanter och avgifter",
      "tax_planning_lawyer": "Skatteplanering",
      "tax_relief": "Skattelättnad",
      "accounting_support": "Redovisningssupport",
      "business_incorporation_restructuring": "Bolagsbildning & omstrukturering",
      "cryptocurrency_taxes": "Kryptovalutaskatter",
      "irs_audit_representation": "Representation vid IRS-revision",
      "irs_filing": "IRS-deklaration",
      "irs_problem_consulting": "IRS-problemlösningstjänster",
      "new_business_services": "Tjänster för nya företag",
      "payroll_support": "Lönesupport",
      "tax_planning_tax_specialist": "Skatteplanering",
      "tax_preparation": "Skatteförberedelse",
      "tax_problem_consulting_tax_specialist": "Konsulttjänster inom skatteproblem",
      "tax_specialist_other": "Annat",
      "therapist_other": "Annat",
      "battery_service": "Batteritjänst",
      "car_towing": "Bilbogsering",
      "fuel_delivery": "Bränsleleverans",
      "local_hauling": "Lokal transport",
      "long_distance_hauling": "Fjärrtransporter",
      "motorcycle_towing": "Bogsering av motorcykel",
      "special_vehicle_towing": "Bogsering av specialfordon",
      "tire_change": "Däckbyte",
      "towing_other": "Annat",
      "case_assessment_traffic_lawyer": "Fallbedömning",
      "cdl_traffic_ticket": "CDL-trafikböter",
      "dui_dwi_traffic_lawyer": "Rattfylla",
      "fixit_ticket": "Åtgärda-bot",
      "parking_ticket": "Parkeringsböter",
      "reckless_driving_traffic_lawyer": "Vårdslös körning",
      "red_light_ticket": "Rödljusbot",
      "speeding_ticket": "Fortkörningsböter",
      "suspended_license": "Pausat körkort",
      "traffic_lawyer_other": "Annat",
      "traffic_ticket": "Trafikbot",
      "cabling_and_bracing": "Kabeldragning och stagning",
      "stump_removal": "Stubbborttagning",
      "tree_planting": "Trädplantering",
      "tree_removal": "Borttagning av träd",
      "tree_service_other": "Annat",
      "tree_transplanting": "Trädplantering",
      "tree_trimming_and_pruning": "Trimning och beskärning av träd",
      "tutor_computer_science": "Datavetenskap",
      "tutor_foreign_languages": "Utländska språk",
      "tutor_geography": "Geografi",
      "tutor_government_and_economics": "Offentlig förvaltning och ekonomi",
      "tutor_history": "Historia",
      "tutor_homework_help": "Läxhjälp",
      "tutor_math": "Matte",
      "tutor_other": "Annat",
      "tutor_reading_and_writing": "Läsa och skriva",
      "tutor_science": "Vetenskap",
      "tutor_special_education": "Specialutbildning",
      "tutor_test_pre_college_entrance": "Testförberedelser: collegeantagning",
      "tutor_test_prep_grad_school_entrance": "Testförberedelser: antagning till forskarutbildning",
      "tutor_test_prep_k8": "Testförberedelse: K-8",
      "area_rug_cleaning": "Rengöring av mattor",
      "drapery_and_blind_cleaning": "Rengöring av gardiner och persienner",
      "leather_cleaning": "Rengöring av läder",
      "mattress_cleaning": "Rengöring av madrasser",
      "upholstery_cleaner_other": "Annat",
      "upholstery_cleaning": "Möbelrengöring",
      "upholstery_water_damage_cleanup": "Vattenskadesanering",
      "bird_exotic_animal_care": "Vård av fåglar och exotiska djur",
      "farm_barn_animal_care": "Djurvård för gård och ladugård",
      "microchipping": "Mikrochipning",
      "veterinarian_allergies": "Allergier",
      "veterinarian_behavior_counseling": "Beteenderådgivning",
      "veterinarian_dental_care": "Tandvård",
      "veterinarian_dermatology": "Dermatologi",
      "veterinarian_emergency_care": "Akutvård",
      "veterinarian_end_of_life_care": "Vård i livets slutskede",
      "veterinarian_examinations": "Undersökningar",
      "veterinarian_nutrition_counseling": "Näringsrådgivning",
      "veterinarian_other": "Annat",
      "veterinarian_preventive_care": "Förebyggande vård",
      "veterinarian_spay_neuter": "Sterilisera eller kastrera",
      "veterinarian_surgery": "Kirurgi",
      "veterinarian_vaccinations": "Vaccinationer",
      "aerial_videography": "Luftburen videografi",
      "documentary_video_production": "Dokumentärproduktion",
      "family_video_production": "Familjevideoproduktion",
      "live_streaming": "Live-sändning",
      "photography": "Fotografi",
      "product_demonstrations": "Produktdemonstration",
      "promotional_video_production": "Kampanjvideoproduktion",
      "real_estate_video_production": "Videoproduktion för fastighetsbranschen",
      "special_event_video_production": "Videoproduktion för särskilt evenemang",
      "video_editing": "Videoredigering",
      "videographer_other": "Annat",
      "voice_overs": "Röstöverlägg",
      "wedding_video_production": "Bröllopsvideoproduktion",
      "fire_damage_cleanup_repair": "Sanering/reparation av brandskador",
      "water_damage_cleanup_repair": "Vattenskadesanering",
      "water_damage_flooring": "Golvläggning",
      "water_damage_mold_inspection": "Mögelinspektion",
      "water_damage_mold_removal": "Mögelborttagning",
      "water_damage_other": "Annat",
      "water_damage_painting": "Målning",
      "water_damage_pest_control": "Skadedjurskontroll",
      "water_damage_plumbing": "Rörmokeri",
      "water_damage_remodeling": "Ombyggnad",
      "water_damage_roofing": "Takläggning",
      "water_damage_sewage_cleanup": "Avloppsrensning",
      "adult_weight_loss_programs": "Viktminskningsprogram för vuxna",
      "diet_and_nutrition_counseling": "Kost- och näringsrådgivning",
      "kids_weight_loss_programs": "Viktminskningsprogram för barn",
      "metabolic_testing": "Metaboliktest",
      "weight_loss_consultation_and_training": "Konsultation och utbildning",
      "weight_loss_fitness_programs": "Träningsprogram",
      "weight_loss_meal_planning": "Måltidsplanering",
      "weight_loss_personal_training": "Personlig träning",
      "weight_loss_service_other": "Annat",
      "weight_loss_wellness_programs": "Wellnessprogram",
      "glass_and_mirror_cleaning": "Rengöring av glas och speglar",
      "gutter_cleaning": "Rengöring av hängrännor",
      "power_pressure_washing": "Kraft/högtryckstvätt",
      "rooftop_skylight_cleaning": "Rengöring av tak och takfönster",
      "window_cleaner_other": "Annat",
      "window_cleaning": "Fönstertvätt",
      "door_installation": "Dörrinstallation",
      "door_repair": "Reparera dörr",
      "glass_installation": "Glasinstallation",
      "window_boardup": "Boardup",
      "window_installation": "Fönsterinstallation",
      "window_repair": "Fönsterreparation",
      "window_repair_other": "Annat",
      "install_new_wiper_blades": "Installera nya torkarblad",
      "repair_power_window": "Reparera elhiss",
      "repair_water_leak": "Reparera vattenläckan",
      "repair_windshield": "Reparation av vindruta",
      "replace_rear_window": "Ersätt bakruta",
      "replace_side_view_mirrors": "Reparera sidospeglar",
      "replace_side_window": "Ersätt sidofönstret",
      "replace_sunroof": "Ersätt soltaksglaset",
      "replace_windshield": "Ersätt vindruta",
      "windshield_other": "Annat",
      "ashtanga": "Ashtanga",
      "hatha": "Hatha",
      "hot_yoga": "Hot yoga",
      "iyengar": "Iyengar",
      "kundalini": "Kundalini",
      "meditation": "Meditation",
      "power_yoga": "Power Yoga",
      "restorative": "Återställande",
      "vinyasa": "Vinyasa",
      "yin": "Yin",
      "yoga_instructor_other": "Annat"
    }
  }
}
